{********************************************************************}
{ written by TMS Software                                            }
{            copyright (c) 2025                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCFilterDialog;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, Types, UITypes
  , WEBLib.TMSFNCCustomDialog, WEBLib.Controls, WEBLib.TMSFNCTypes, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorButton, TMS.TMSFNCValue
  , TMS.TMSFNCFilterBuilder, WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes, WEBLib.TMSFNCEditorDropDownEdit
  , SysUtils, Generics.Collections, WEBLib.Forms
  , Data.DB
  {$IFDEF FMXLIB}
  , FMX.Layouts, FMX.Edit, FMX.Types
  {$ENDIF}
  {$IFNDEF FMXLIB}
  , VCL.StdCtrls, VCL.ExtCtrls
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.ExtCtrls, WEB
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,FMX.Memo, FMX.ComboEdit
  {$ENDIF}
  ;

resourcestring
  sTMSFNCFilterBuilderUILanguageClose = 'Close';
  sTMSFNCFilterBuilderUILanguageApply = 'Apply';
  sTMSFNCFilterBuilderUILanguageOk = 'OK';
  sTMSFNCFilterBuilderUILanguageClear = 'Clear';
  sTMSFNCFilterBuilderUILanguageCancel = 'Cancel';
  sTMSFNCFilterBuilderUILanguageCaption = 'Filter';
  sTMSFNCFilterBuilderUILanguageAndOperatorText = 'AND';
  sTMSFNCFilterBuilderUILanguageOrOperatorText = 'OR';
  sTMSFNCFilterBuilderUILanguageEmptyOperatorText = 'is Empty';
  sTMSFNCFilterBuilderUILanguageEqualOperatorText = 'equals';
  sTMSFNCFilterBuilderUILanguageEqualOperatorNumber = '=';  
  sTMSFNCFilterBuilderUILanguageNotEqualOperatorNumber = '<>';  
  sTMSFNCFilterBuilderUILanguageLargerThanOrEqualOperatorText = '>=';
  sTMSFNCFilterBuilderUILanguageLargerThanOperatorText = '>';
  sTMSFNCFilterBuilderUILanguageSmallerThanOrEqualOperatorText = '<=';
  sTMSFNCFilterBuilderUILanguageSmallerThanOperatorText = '<';  
  sTMSFNCFilterBuilderUILanguageNotEmptyOperatorText = 'is Not Empty';
  sTMSFNCFilterBuilderUILanguageNotEqualOperatorText = 'is Not Equal';
  sTMSFNCFilterBuilderUILanguageStartsWithOperatorText = 'starts with';
  sTMSFNCFilterBuilderUILanguageEndsWithOperatorText = 'ends with';
  sTMSFNCFilterBuilderUILanguageContainsOperatorText = 'contains';
  sTMSFNCFilterBuilderUILanguageNotContainsOperatorText = 'does not contain';
  sTMSFNCFilterBuilderUILanguageAddExpression = 'Add Expression';
  sTMSFNCFilterBuilderUILanguageAddGroup = 'Add Group';
  sTMSFNCFilterBuilderUILanguageAddHint = 'Add Condition';
  sTMSFNCFilterBuilderUILanguageRemoveHint = 'Remove Condition';
  sTMSFNCFilterBuilderUILanguageNotHint = 'Invert Expression';
  sTMSFNCFilterBuilderUILanguageColumnNameHint = 'Set Column Name';
  sTMSFNCFilterBuilderUILanguageOperatorHint = 'Set Operator';
  sTMSFNCFilterBuilderUILanguageValueHint = 'Set Value';
//  sTMSFNCFilterBuilderUILanguageCaseHint = 'Set Case Sensitivity';

  sTMSFNCFilterBuilderUILanguageTrue = 'True';
  sTMSFNCFilterBuilderUILanguageFalse = 'False';

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 1; // Build nr.

  //version history
  //v0.9.0.0: First BETA Release
  //v0.9.0.1: New : TTMSFNCFilterDialog introduced
  //        : Fixed : DataSet Date/Time string formatting
  //v0.9.0.2: Improved : Hints are shown
  //v0.9.1.0: New : Support for user friendly names in columns with property DisplayName
  //        : Improved : ValidateFilterRow and ValidateFilterArray set public
  //        : Improved : fdtOther type introduced for non standard types like eg. Graphics
  //        : Fixed : DataSet ftTimeStamp support
  //v1.0.0.0: Release version
  //        : New : OK Button added
  //        : Improved : Non modal behaviour improved
  //v1.0.0.1: Fixed : Naming issue in C++ with OKButton event


  COMBOTYPES = [fdtBoolean, fdtDateTime, fdtDate, fdtTime];

  TTMSFNCADDBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9z'
    + 'dmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjRweCIgaGVpZ2h0PS'
    + 'IyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0'
    + 'eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDojMDA3N2JlOyIgZD0iTSAxMiAwIEMgNS4zOD'
    + 'I4MTIgMCAwIDUuMzgyODEyIDAgMTIgQyAwIDE4LjYxNzE4OCA1LjM4MjgxMiAyNCAxMiAyNCBDIDE4LjYxNzE4OCAy'
    + 'NCAyNCAxOC42MTcxODggMjQgMTIgQyAyNCA1LjM4MjgxMiAxOC42MTcxODggMCAxMiAwIFogTSAxMiAyMi4xNDA2Mj'
    + 'UgQyA2LjQxMDE1NiAyMi4xNDA2MjUgMS44NTkzNzUgMTcuNTkzNzUgMS44NTkzNzUgMTIgQyAxLjg1OTM3NSA2LjQw'
    + 'NjI1IDYuNDEwMTU2IDEuODU5Mzc1IDEyIDEuODU5Mzc1IEMgMTcuNTg5ODQ0IDEuODU5Mzc1IDIyLjE0MDYyNSA2Lj'
    + 'QwNjI1IDIyLjE0MDYyNSAxMiBDIDIyLjE0MDYyNSAxNy41OTM3NSAxNy41OTM3NSAyMi4xNDA2MjUgMTIgMjIuMTQw'
    + 'NjI1IFogTSAxMiAyMi4xNDA2MjUgIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm'
    + '87ZmlsbDojMDA3N2JlO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAxNi42NDg0MzggMTAuOTg4MjgxIEwgMTIuOTI5Njg4'
    + 'IDEwLjk4ODI4MSBMIDEyLjkyOTY4OCA3LjI2OTUzMSBDIDEyLjkyOTY4OCA2Ljc1MzkwNiAxMi41MTU2MjUgNi4zMz'
    + 'k4NDQgMTIgNi4zMzk4NDQgQyAxMS40ODQzNzUgNi4zMzk4NDQgMTEuMDcwMzEyIDYuNzUzOTA2IDExLjA3MDMxMiA3'
    + 'LjI2OTUzMSBMIDExLjA3MDMxMiAxMC45ODgyODEgTCA3LjM1MTU2MiAxMC45ODgyODEgQyA2LjgzOTg0NCAxMC45OD'
    + 'gyODEgNi40MjE4NzUgMTEuNDAyMzQ0IDYuNDIxODc1IDExLjkxNzk2OSBDIDYuNDIxODc1IDEyLjQyOTY4OCA2Ljgz'
    + 'OTg0NCAxMi44NDc2NTYgNy4zNTE1NjIgMTIuODQ3NjU2IEwgMTEuMDcwMzEyIDEyLjg0NzY1NiBMIDExLjA3MDMxMi'
    + 'AxNi41NjI1IEMgMTEuMDcwMzEyIDE3LjA3ODEyNSAxMS40ODQzNzUgMTcuNDkyMTg4IDEyIDE3LjQ5MjE4OCBDIDEy'
    + 'LjUxNTYyNSAxNy40OTIxODggMTIuOTI5Njg4IDE3LjA3ODEyNSAxMi45Mjk2ODggMTYuNTYyNSBMIDEyLjkyOTY4OC'
    + 'AxMi44NDc2NTYgTCAxNi42NDg0MzggMTIuODQ3NjU2IEMgMTcuMTYwMTU2IDEyLjg0NzY1NiAxNy41NzgxMjUgMTIu'
    + 'NDI5Njg4IDE3LjU3ODEyNSAxMS45MTc5NjkgQyAxNy41NzgxMjUgMTEuNDAyMzQ0IDE3LjE2MDE1NiAxMC45ODgyOD'
    + 'EgMTYuNjQ4NDM4IDEwLjk4ODI4MSBaIE0gMTYuNjQ4NDM4IDEwLjk4ODI4MSAiLz4KPC9nPgo8L3N2Zz4K';

  TTMSFNCREMOVEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBpZD0iSWNvbnMiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI1MTIiIH'
    + 'htbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iIzAwNzdiZSIgZD0ibTEyIDFhMTEgMTEgMCAxIDAg'
    + 'MTEgMTEgMTEuMDEzIDExLjAxMyAwIDAgMCAtMTEtMTF6bTAgMjBhOSA5IDAgMSAxIDktOSA5LjAxIDkuMDEgMCAwIDEgLTkgOXoiLz'
    + '48cGF0aCBmaWxsPSIjMDA3N2JlIiBkPSJtMTYgMTFoLThhMSAxIDAgMCAwIDAgMmg4YTEgMSAwIDAgMCAwLTJ6Ii8+PC9zdmc+';

  TTMSFNCNOTBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzd'
    + 'HJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJDYX'
    + 'BhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0'
    + 'iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMjsiIHhtbDpzcGFjZT0icHJlc2VydmUi'
    + 'Pg0KPGc+DQoJPGc+DQoJCTxwYXRoIGQ9Ik0yNTYsMEMxMTQuODQ0LDAsMCwxMTQuODQ0LDAsMjU2czExNC44NDQsMjU2LDI1NiwyNTZzMjU2LTExNC44NDQsMjU2L'
    + 'TI1NlMzOTcuMTU2LDAsMjU2LDB6IE0yNTYsNDQ4DQoJCQljLTEwNS44NjUsMC0xOTItODYuMTM1LTE5Mi0xOTJjMC00MC40MDYsMTIuMjUtNzguNjA0LDM1LjU0Mi'
    + '0xMTEuMTk4bDI2Ny42NTYsMjY3LjY1NkMzMzQuNjA0LDQzNS43NSwyOTYuNDA2LDQ0OCwyNTYsNDQ4eg0KCQkJIE00MTIuNDU4LDM2Ny4xOThMMTQ0LjgwMiw5OS4'
    + '1NDJDMTc3LjM5Niw3Ni4yNSwyMTUuNTk0LDY0LDI1Niw2NGMxMDUuODY1LDAsMTkyLDg2LjEzNSwxOTIsMTkyDQoJCQlDNDQ4LDI5Ni40MDYsNDM1Ljc1LDMzNC42'
    + 'MDQsNDEyLjQ1OCwzNjcuMTk4eiIgZmlsbD0iIzg4ODg4OCIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K';

//  TTMSFNCCASEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwO'
//    + 'i8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzg4ODg4OCI+PHBhdGggZD0ibTM4LjA5OTk3NTYgMjEuMjk5OTg3OGgtMTUuMDY5OTQ2M2wtMjAuNTMwMDI5MyA1Ni4'
//    + '0MDk5NzMxaDEzLjc3MDAxOTVsMy45Njk5NzA3LTEyLjU0OTk4NzhoMjAuMDU5OTk3Nmw0LjAyMDAxOTUgMTIuNTQ5OTg3OGgxMy44Mzk5NjU4em0tMTUuMTM5OTUzNiAzNC4xM'
//    + 'Dk5ODUzIDcuMjI5OTgwNS0yMi41NTk5OTc2IDcuMjAwMDEyMiAyMi41NTk5OTc2eiIvPjxwYXRoIGQ9Im04MC4yNzAwMTk1IDM2LjQ1MDAxMjJjLTIuNDYwMDIyIDAtNS4yMDA'
//    + 'wMTIyLjMzOTk2NTgtOC4yMDAwMTIyIDEuMDE5OTU4NS0zLjAxMDAwOTguNjc5OTkyNy01LjM2OTk5NTEgMS40NzAwMzE3LTcuMTAwMDM2NiAyLjM1OTk4NTR2OS4zNjAwNDY0Y'
//    + 'zQuMzMwMDE3MS0yLjg1MDAzNjYgOC44OTAwMTQ2LTQuMjgwMDI5MyAxMy42OTAwMDI0LTQuMjgwMDI5MyA0Ljc3MDAxOTUgMCA3LjE2MDAzNDIgMi4yMDAwMTIyIDcuMTYwMDM'
//    + '0MiA2LjYwMDAzNjZsLTEwLjk0MDAwMjQgMS40NTk5NjA5Yy05LjI2MDAwOTggMS4yMTAwMjItMTMuODkwMDE0NyA1LjcyMDAzMTctMTMuODkwMDE0NyAxMy41MzAwMjkzIDAgM'
//    + 'y43MDAwMTIyIDEuMTMwMDA0OSA2LjY1OTk3MzEgMy4zNjk5OTUxIDguODY5OTk1MSAyLjIzOTk5MDIgMi4yMTk5NzA3IDUuMzA5OTk3NiAzLjMzMDAxNzEgOS4yMjAwMzE3IDM'
//    + 'uMzMwMDE3MSA1LjI5OTk4NzggMCA5LjI5OTk4NzgtMi4yNjAwMDk4IDEyLTYuNzcwMDE5NWguMTU5OTczMXY1Ljc3OTk2ODNoMTEuNzYwMDA5OXYtMjQuMDY5OTQ2NGMwLTExL'
//    + 'jQ2MDAyMTktNS43Mzk5OTAyLTE3LjE5MDAwMjQtMTcuMjI5OTgwNS0xNy4xOTAwMDI0em01LjU0OTk4NzggMjQuODk5OTYzNGMwIDIuNDcwMDMxNy0uNzM5OTkwMiA0LjUtMi4'
//    + 'yMTAwMjIgNi4xMTk5OTUxLTEuNDY5OTcwNyAxLjYwOTk4NTQtMy4zNjk5OTUxIDIuNDEwMDM0Mi01LjcwMDAxMjIgMi40MTAwMzQyLTEuNjc5OTkyNyAwLTMuMDA5OTQ4Ny0uN'
//    + 'DUwMDEyMi0zLjk4OTk5MDItMS4zNTAwMzY2LS45ODk5OTAyLS45MDk5NzMxLTEuNDc5OTgwNS0yLjA3MDAwNzMtMS40Nzk5ODA1LTMuNDc5OTgwNSAwLTMuMTE5OTk1MSAyLjA'
//    + 'yMDAxOTUtNC45NTAwMTIyIDYuMDU5OTk3Ni01LjQ3MDAzMTdsNy4zMjAwMDczLS45NDk5NTEyeiIvPjwvZz48L3N2Zz4=';
type

  TTMSFNCFilterDialogUILanguage = class(TPersistent)
  private
    FCaption: string;
    FClose: string;
    FAndOperatorText: string;
    FOrOperatorText: string;
    FOnInternalChanged: TNotifyEvent;
    FSmallerThanOrEqualOperatorText: string;
    FLargerThanOperatorText: string;
    FEqualOperatorText: string;
    FSmallerThanOperatorText: string;
    FNotEqualOperatorText: string;
    FEmptyOperatorText: string;
    FLargerThanOrEqualOperatorText: string;
    FNotEmptyOperatorText: string;
    FStartsWithOperatorText: string;
    FEndsWithOperatorText: string;
    FContainsOperatorText: string;
    FNotContainsOperatorText: string;
    FCancel: string;
    FApply: string;
    FClear: string;
    FAddGroup: string;
    FAddExpression: string;
    FFalseText: string;
    FTrueText: string;
    FOperatorHint: string;
    FNotHint: string;
    FAddHint: string;
    FValueHint: string;
    FRemoveHint: string;
    FColumnNameHint: string;
    FOK: string;
//    FCaseHint: string;
    function IsCaptionStored: Boolean;
    function IsCloseStored: Boolean;
    function IsAndOperatorTextStored: Boolean;
    function IsOrOperatorTextStored: Boolean;
    function IsEmptyOperatorTextStored: Boolean;
    function TrueOperatorTextStored: Boolean;
    function FalseOperatorTextStored: Boolean;
    function IsEqualOperatorTextStored: Boolean;
    function IsLargerThanOrEqualOperatorTextStored: Boolean;
    function IsLargerThanOperatorTextStored: Boolean;
    function IsSmallerThanOrEqualOperatorTextStored: Boolean;
    function IsSmallerThanOperatorTextStored: Boolean;
    function IsNotEmptyOperatorTextStored: Boolean;
    function IsNotEqualOperatorTextStored: Boolean;
    function IsContainsOperatorTextStored: Boolean;
    function IsEndsWithOperatorTextStored: Boolean;
    function IsNotContainsOperatorTextStored: Boolean;
    function IsStartsWithOperatorTextStored: Boolean;
    function IsApplyStored: Boolean;
    function IsCancelStored: Boolean;
    function IsClearStored: Boolean;
    function IsAddExpressionStored: Boolean;
    function IsAddGroupStored: Boolean;
    function IsAddHintStored: Boolean;
    function IsColumnNameHintStored: Boolean;
    function IsNotHintStored: Boolean;
    function IsOperatorHintStored: Boolean;
    function IsRemoveHintStored: Boolean;
    function IsValueHintStored: Boolean;
    function IsOKStored: Boolean;
//    function IsCaseHintStored: Boolean;
  protected
    procedure DoChanged;
  public
    constructor Create;
    procedure Assign(Source: TPersistent); override;
    property OnInternalChanged: TNotifyEvent read FOnInternalChanged write FOnInternalChanged;
  published
    property Clear: string read FClear write FClear stored IsClearStored;
    property Apply: string read FApply write FApply stored IsApplyStored;
    property OK: string read FOK write FOK stored IsOKStored;
    property Cancel: string read FCancel write FCancel stored IsCancelStored;
    property Close: string read FClose write FClose stored IsCloseStored;
    property Caption: string read FCaption write FCaption stored IsCaptionStored;
    property AndOperatorText: string read FAndOperatorText write FAndOperatorText stored IsAndOperatorTextStored;
    property OrOperatorText: string read FOrOperatorText write FOrOperatorText stored IsOrOperatorTextStored;
    property EqualOperatorText: string read FEqualOperatorText write FEqualOperatorText stored IsEqualOperatorTextStored;
    property NotEqualOperatorText: string read FNotEqualOperatorText write FNotEqualOperatorText stored IsNotEqualOperatorTextStored;
    property SmallerThanOperatorText: string read FSmallerThanOperatorText write FSmallerThanOperatorText stored IsSmallerThanOperatorTextStored;
    property SmallerThanOrEqualOperatorText: string read FSmallerThanOrEqualOperatorText write FSmallerThanOrEqualOperatorText stored IsSmallerThanOrEqualOperatorTextStored;
    property LargerThanOperatorText: string read FLargerThanOperatorText write FLargerThanOperatorText stored IsLargerThanOperatorTextStored;
    property LargerThanOrEqualOperatorText: string read FLargerThanOrEqualOperatorText write FLargerThanOrEqualOperatorText stored IsLargerThanOrEqualOperatorTextStored;
    property EmptyOperatorText: string read FEmptyOperatorText write FEmptyOperatorText stored IsEmptyOperatorTextStored;
    property NotEmptyOperatorText: string read FNotEmptyOperatorText write FNotEmptyOperatorText stored IsNotEmptyOperatorTextStored;
    property StartsWithOperatorText: string read FStartsWithOperatorText write FStartsWithOperatorText stored IsStartsWithOperatorTextStored;
    property EndsWithOperatorText: string read FEndsWithOperatorText write FEndsWithOperatorText stored IsEndsWithOperatorTextStored;
    property ContainsOperatorText: string read FContainsOperatorText write FContainsOperatorText stored IsContainsOperatorTextStored;
    property NotContainsOperatorText: string read FNotContainsOperatorText write FNotContainsOperatorText stored IsNotContainsOperatorTextStored;
    property TrueText: string read FTrueText write FTrueText stored TrueOperatorTextStored;
    property FalseText: string read FFalseText write FFalseText stored FalseOperatorTextStored;
    property AddExpression: string read FAddExpression write FAddExpression stored IsAddExpressionStored;
    property AddGroup: string read FAddGroup write FAddGroup stored IsAddGroupStored;
    property AddHint: string read FAddHint write FAddHint stored IsAddHintStored;
    property RemoveHint: string read FRemoveHint write FRemoveHint stored IsRemoveHintStored;
    property NotHint: string read FNotHint write FNotHint stored IsNotHintStored;
//    property CaseHint: string read FCaseHint write FCaseHint stored IsCaseHintStored;
    property ColumnNameHint: string read FColumnNameHint write FColumnNameHint stored IsColumnNameHintStored;
    property OperatorHint: string read FOperatorHint write FOperatorHint stored IsOperatorHintStored;
    property ValueHint: string read FValueHint write FValueHint stored IsValueHintStored;
  end;

  TTMSFNCFilterDialogButton = (fdbApply, fdbCancel, fdbClear, fdbOk);
  TTMSFNCFilterDialogButtons = set of TTMSFNCFilterDialogButton;

  TTMSFNCFilterDialogCustomOptions = class(TPersistent)
  private
    FUILanguage: TTMSFNCFilterDialogUILanguage;
    FOnInternalChanged: TNotifyEvent;
    FButtons: TTMSFNCFilterDialogButtons;
    procedure SetUILanguage(const Value: TTMSFNCFilterDialogUILanguage);
    procedure SetButtons(const Value: TTMSFNCFilterDialogButtons);
    function IsButtonsStored: Boolean;
  protected
    procedure DoInternalChanged;
    property UILanguage: TTMSFNCFilterDialogUILanguage read FUILanguage write SetUILanguage;
    property Buttons: TTMSFNCFilterDialogButtons read FButtons write SetButtons stored IsButtonsStored;
	property OnInternalChanged: TNotifyEvent read FOnInternalChanged write FOnInternalChanged;	
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  end;
  
  TTMSFNCFilterDialogOptions = class(TTMSFNCFilterDialogCustomOptions)
  published
    property UILanguage;
    property Buttons;
  end;

  TTMSFNCFilterDialogDarkStyleChanged = procedure(Sender: TObject; ADarkStyle: Boolean) of object;

  TTMSFNCFilterDialogAppearance = class(TPersistent)
  private
    FExpressionValueFill: TTMSFNCGraphicsFill;
    FExpressionColumnFill: TTMSFNCGraphicsFill;
    FExpressionOperatorFont: TTMSFNCGraphicsFont;
    FGroupFont: TTMSFNCGraphicsFont;
    FExpressionOperatorFill: TTMSFNCGraphicsFill;
    FGroupFill: TTMSFNCGraphicsFill;
    FExpressionValueFont: TTMSFNCGraphicsFont;
    FExpressionColumnFont: TTMSFNCGraphicsFont;
    FOnInternalChanged: TNotifyEvent;
    FIndent: Integer;
    FItemHeight: Integer;
    FItemRounding: Integer;
    FItemControlsMargins: TTMSFNCMargins;
    FConnectionLine: TTMSFNCGraphicsStroke;
    FHoverFill: TTMSFNCGraphicsFill;
    FHoverPartStroke: TTMSFNCGraphicsStroke;
    FDropDownHoverFont: TTMSFNCGraphicsFont;
    FDropDownHoverFill: TTMSFNCGraphicsFill;
    FDarkStyleControls: Boolean;
    FOnDarkStyleChanged: TTMSFNCFilterDialogDarkStyleChanged;
    FThemeColor: TTMSFNCGraphicsColor;
    FThemeFontColor: TTMSFNCGraphicsColor;
    procedure SetExpressionColumnFill(const Value: TTMSFNCGraphicsFill);
    procedure SetExpressionColumnFont(const Value: TTMSFNCGraphicsFont);
    procedure SetExpressionOperatorFill(const Value: TTMSFNCGraphicsFill);
    procedure SetExpressionOperatorFont(const Value: TTMSFNCGraphicsFont);
    procedure SetExpressionValueFill(const Value: TTMSFNCGraphicsFill);
    procedure SetExpressionValueFont(const Value: TTMSFNCGraphicsFont);
    procedure SetGroupFill(const Value: TTMSFNCGraphicsFill);
    procedure SetGroupFont(const Value: TTMSFNCGraphicsFont);
    procedure SetIndent(const Value: Integer);
    procedure SetItemHeight(const Value: Integer);
    procedure SetItemRounding(const Value: Integer);
    procedure SetItemControlsMargins(const Value: TTMSFNCMargins);
    procedure SetConnectionLine(const Value: TTMSFNCGraphicsStroke);
    procedure SetHoverFill(const Value: TTMSFNCGraphicsFill);
    procedure SetHoverPartStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetDropDownHoverFill(const Value: TTMSFNCGraphicsFill);
    procedure SetDropDownHoverFont(const Value: TTMSFNCGraphicsFont);
    procedure SetDarkStyleControls(const Value: Boolean);
    procedure SetThemeColor(const Value: TTMSFNCGraphicsColor);
    function IsThemeColorStored: Boolean;
    function IsThemeFontColorStored: Boolean;
    procedure SetThemeFontColor(const Value: TTMSFNCGraphicsColor);
  protected
    procedure ChangeDPIScale(M: Integer; D: Integer);
    procedure DoOnFillChanged(Sender: TObject);
    procedure DoOnFontChanged(Sender: TObject);
    procedure DoOnStrokeChanged(Sender: TObject);
    procedure DoChanged;
    procedure DoDarkStyleChanged(AIsDark: Boolean);
    property OnInternalChanged: TNotifyEvent read FOnInternalChanged write FOnInternalChanged;
    property OnDarkStyleChanged: TTMSFNCFilterDialogDarkStyleChanged read FOnDarkStyleChanged write FOnDarkStyleChanged;
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property GroupFill: TTMSFNCGraphicsFill read FGroupFill write SetGroupFill;
    property ExpressionColumnFill: TTMSFNCGraphicsFill read FExpressionColumnFill write SetExpressionColumnFill;
    property ExpressionOperatorFill: TTMSFNCGraphicsFill read FExpressionOperatorFill write SetExpressionOperatorFill;
    property ExpressionValueFill: TTMSFNCGraphicsFill read FExpressionValueFill write SetExpressionValueFill;
    property GroupFont: TTMSFNCGraphicsFont read FGroupFont write SetGroupFont;
    property ExpressionColumnFont: TTMSFNCGraphicsFont read FExpressionColumnFont write SetExpressionColumnFont;
    property ExpressionOperatorFont: TTMSFNCGraphicsFont read FExpressionOperatorFont write SetExpressionOperatorFont;
    property ExpressionValueFont: TTMSFNCGraphicsFont read FExpressionValueFont write SetExpressionValueFont;
    property HoverFill: TTMSFNCGraphicsFill read FHoverFill write SetHoverFill;
    property HoverPartStroke: TTMSFNCGraphicsStroke read FHoverPartStroke write SetHoverPartStroke;
    property ConnectionLine: TTMSFNCGraphicsStroke read FConnectionLine write SetConnectionLine;
    property DropDownHoverFill: TTMSFNCGraphicsFill read FDropDownHoverFill write SetDropDownHoverFill;
    property DropDownHoverFont: TTMSFNCGraphicsFont read FDropDownHoverFont write SetDropDownHoverFont;
    property Indent: Integer read FIndent write SetIndent default 20;
    property ItemHeight: Integer read FItemHeight write SetItemHeight default 30;
    property ItemRounding: Integer read FItemRounding write SetItemRounding default 4;
    property ItemControlsMargins: TTMSFNCMargins read FItemControlsMargins write SetItemControlsMargins;
    property DarkStyleControls: Boolean read FDarkStyleControls write SetDarkStyleControls default False;
    property ThemeColor: TTMSFNCGraphicsColor read FThemeColor write SetThemeColor stored IsThemeColorStored;
    property ThemeFontColor: TTMSFNCGraphicsColor read FThemeFontColor write SetThemeFontColor stored IsThemeFontColorStored;
  end;

  TTMSFNCFilterDialogDrawItemPart = (ddipNone, ddipName, ddipOperator, ddipValue, ddipExtraValue, ddipAdd, ddipDelete, ddipNot{, ddipCase});
  TTMSFNCFilterDialogEditorType = (vetEdit, vetComboEdit, vetComboBox, vetDatePicker, vetTimePicker, vetCustom);

  TTMSFNCFilterDialogEditorProperties = record
    EditorPart: TTMSFNCFilterDialogDrawItemPart;
    EditorType: TTMSFNCFilterDialogEditorType;
    EditorText: string;
    EditorDate: TDateTime;
    EditorRect: TRectF;
  end;

  TTMSFNCFilterDialogGetFilterBuilder = procedure(Sender: TObject; var AFilterBuilder: TTMSFNCFilterBuilder) of object;
  TTMSFNCFilterDialogGetFilterBuilderColumns = procedure(Sender: TObject; AFilterBuilder: TTMSFNCFilterBuilder; ADataColumns: TTMSFNCFilterBuilderColumns) of object;
  TTMSFNCFilterDialogGetFormatSettings = procedure(Sender: TObject; var AFormatSettings: TFormatSettings) of object;
  TTMSFNCFilterDialogShowGroupEditor = procedure(Sender: TObject; AGroup: TTMSFNCFilterBuilderGroup; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; APossibleValues: TStringList; var AFixed: Boolean; var AShow: Boolean) of object;
  TTMSFNCFilterDialogShowExpressionEditor = procedure(Sender: TObject; AExpression: TTMSFNCFilterBuilderExpression; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; AValues: TStringList; var AFixed: Boolean; var AShow: Boolean) of object;
  TTMSFNCFilterDialogButtonClicked = procedure(Sender: TObject; AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean) of object;
  TTMSFNCFilterDialogButtonClearClicked = procedure(Sender: TObject; AFilterBuilder: TTMSFNCFilterBuilder; var AClear: Boolean) of object;

  TTMSFNCFilterDialogDrawItem = class
  private
    FExpression: TTMSFNCFilterBuilderExpression;
    FGroup: TTMSFNCFilterBuilderGroup;
    FIsSelected: Boolean;
    FRect: TRectF;
    FColumnNameRect: TRectF;
    FOperatorRect: TRectF;
    FValueRect: TRectF;
    FColumnNameArrowRect: TRectF;
    FOperatorArrowRect: TRectF;
    FValueArrowRect: TRectF;
    FColumnNameTextRect: TRectF;
    FOperatorTextRect: TRectF;
    FValueTextRect: TRectF;
    FArrowSpace: Single;
    FColumnNameText: string;
    FOperatorText: string;
    FValueText: string;
    FValueType: TTMSFNCFilterBuilderDataType;
    FLevel: Integer;
    FIndex: Integer;
    FEndIndex: Integer;
    FRounding: Single;
    FAddRect: TRectF;
    FDeleteRect: TRectF;
    FExtraValueText: string;
    FExtraValueTextRect: TRectF;
    FExtraValueRect: TRectF;
    FExtraValueArrowRect: TRectF;
    FValue: TTMSFNCValue;
    FNotRect: TRectF;
    FIsInverted: Boolean;
//    FCaseRect: TRectF;
//    FCaseSensitive: Boolean;
  public
    property Expression: TTMSFNCFilterBuilderExpression read FExpression write FExpression;
    property Group: TTMSFNCFilterBuilderGroup read FGroup write FGroup;
    property IsSelected: Boolean read FIsSelected write FIsSelected default False;
    property Rect: TRectF read FRect write FRect;
    property ColumnNameRect: TRectF read FColumnNameRect write FColumnNameRect;
    property OperatorRect: TRectF read FOperatorRect write FOperatorRect;
    property NotRect: TRectF read FNotRect write FNotRect;
//    property CaseRect: TRectF read FCaseRect write FCaseRect;
    property ValueRect: TRectF read FValueRect write FValueRect;
    property ColumnNameArrowRect: TRectF read FColumnNameArrowRect write FColumnNameArrowRect;
    property OperatorArrowRect: TRectF read FOperatorArrowRect write FOperatorArrowRect;
    property ValueArrowRect: TRectF read FValueArrowRect write FValueArrowRect;
    property ColumnNameTextRect: TRectF read FColumnNameTextRect write FColumnNameTextRect;
    property OperatorTextRect: TRectF read FOperatorTextRect write FOperatorTextRect;
    property ValueTextRect: TRectF read FValueTextRect write FValueTextRect;
    property ExtraValueRect: TRectF read FExtraValueRect write FExtraValueRect;
    property ExtraValueTextRect: TRectF read FExtraValueTextRect write FExtraValueTextRect;
    property ExtraValueArrowRect: TRectF read FExtraValueArrowRect write FExtraValueArrowRect;
    property AddRect: TRectF read FAddRect write FAddRect;
    property DeleteRect: TRectF read FDeleteRect write FDeleteRect;
    property ArrowSpace: Single read FArrowSpace write FArrowSpace;
    property ColumnNameText: string read FColumnNameText write FColumnNameText;
    property OperatorText: string read FOperatorText write FOperatorText;
    property ValueText: string read FValueText write FValueText;
    property ExtraValueText: string read FExtraValueText write FExtraValueText;
    property Value: TTMSFNCValue read FValue write FValue;
    property ValueType: TTMSFNCFilterBuilderDataType read FValueType write FValueType default fdtAutomatic;
    property Level: Integer read FLevel write FLevel default -1;
    property Index: Integer read FIndex write FIndex default -1;
    property EndIndex: Integer read FEndIndex write FEndIndex default -1;
    property Rounding: Single read FRounding write FRounding;
    property IsInverted: Boolean read FIsInverted write FIsInverted;
//    property CaseSensitive: Boolean read FCaseSensitive write FCaseSensitive;
  public
    constructor Create;
    destructor Destroy; override;
  end;

  TTMSFNCFilterDialogDrawItemList = class(TObjectList<TTMSFNCFilterDialogDrawItem>)
  protected
    function AddItem: TTMSFNCFilterDialogDrawItem; overload;
    function AddItem(AExpression: TTMSFNCFilterBuilderExpression; ALevel: Integer = -1): TTMSFNCFilterDialogDrawItem; overload;
    function AddItem(AGroup: TTMSFNCFilterBuilderGroup; ALevel: Integer = -1): TTMSFNCFilterDialogDrawItem; overload;
  end;

  TTMSFNCFilterDialogOpenControlParameters = record
    DrawItem: TTMSFNCFilterDialogDrawItem;
    PartRect: TRectF;
    Text: string;
    DateTime: TDateTime;
    List: TStringList;
    Fixed: Boolean;
    HideEdit: Boolean;
    Part: TTMSFNCFilterDialogDrawItemPart;
    Editor: TTMSFNCFilterDialogEditorType;
  end;

  TTMSFNCCustomFilterDialog = class;

  TTMSFNCFilterPreview = class(TTMSFNCCustomControl)
  private
    FDialog: TTMSFNCCustomFilterDialog;
  protected
    function GetHintString: string; override;
    function HasHint: Boolean; override;
  public
    constructor Create(AOwner: TComponent); override;
    property Dialog: TTMSFNCCustomFilterDialog read FDialog write FDialog;
  end;

  TTMSFNCFilterDialogShowCustomEditor = procedure(Sender: TObject; ADrawItem: TTMSFNCFilterDialogDrawItem; AEditorProperties: TTMSFNCFilterDialogEditorProperties) of object;
  TTMSFNCFilterDialogGetExpressionValues = procedure(Sender: TObject; AColumn: TTMSFNCFilterBuilderColumn; AValues: TStringList) of object;

  TTMSFNCCustomFilterDialog = class(TTMSFNCCustomDialog)
  private
    FIsModal: Boolean;
    FDefaultDropDownHeight: Integer;
    FOriginalFilterBuilder: TTMSFNCFilterBuilder;
    FFilterText: string;
    {$IFNDEF FMXLIB}
    FVScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVScrlBox: TVertScrollBox;
    {$ENDIF}
    FPreview: TTMSFNCFilterPreview;
    FTopPanel, FPanel, FBottomPanel: TTMSFNCEditorPanel;
    FButtonApply, FButtonCancel, FButtonOk, FButtonClear: TTMSFNCEditorButton;
    FExpressionEdit: TEdit;
    FChangeCombo: TTMSFNCEditorDropDownEdit;
    FFilterBuilder: TTMSFNCFilterBuilder;
    FCopyFilterText: string;
    FOnGetFilterBuilder: TTMSFNCFilterDialogGetFilterBuilder;
    FOptions: TTMSFNCFilterDialogOptions;
    FAppearance: TTMSFNCFilterDialogAppearance;
    FOnGetFormatSettings: TTMSFNCFilterDialogGetFormatSettings;
    FDrawItems: TTMSFNCFilterDialogDrawItemList;
    FFilterTimer: TTimer;
    FFilterTime: Integer;
    FMouseDown: Boolean;
    FMouseDrag: Boolean;
    FHoverItemPart: TTMSFNCFilterDialogDrawItemPart;
    FHoveredItemIndex: Integer;
    FEditorOpen: Boolean;
    FEditorPart: TTMSFNCFilterDialogDrawItemPart;
    FEditorIndex: Integer;
    FEditorValueText: string;
    FEditorDate: TDateTime;
    FNotText: string;
    FDialogOpen: Boolean;
    FOnShowExpressionEditor: TTMSFNCFilterDialogShowExpressionEditor;
    FOnShowGroupEditor: TTMSFNCFilterDialogShowGroupEditor;
    FOnGetFilterBuilderDataColumns: TTMSFNCFilterDialogGetFilterBuilderColumns;
    FOnApplyButtonClicked: TTMSFNCFilterDialogButtonClicked;
    FOnCancelButtonClicked: TTMSFNCFilterDialogButtonClicked;
    FOnClearButtonClicked: TTMSFNCFilterDialogButtonClearClicked;
    FOnShowCustomEditor: TTMSFNCFilterDialogShowCustomEditor;
    FOnGetExpressionValues: TTMSFNCFilterDialogGetExpressionValues;
    FOnOKButtonClicked: TTMSFNCFilterDialogButtonClicked;
    procedure SetOptions(const Value: TTMSFNCFilterDialogOptions);
    procedure SetAppearance(const Value: TTMSFNCFilterDialogAppearance);
    procedure ResetHoveredItem;
    procedure ResetChangeControls;
    function GetFilterText: string; virtual;
    procedure SetFilterText(const Value: string); virtual;
    procedure SetFilterBuilder(const Value: TTMSFNCFilterBuilder);
    function GetDisplayFilterText: string;
  protected
    procedure DoOnInternalFilterBuilderChanged(Sender: TObject);
    procedure DoInternalChanged;
    function GetInstance: NativeUInt; override;
    {$IFDEF VCLLIB}
    procedure ChangeDPIScale(M: Integer; D: Integer); override;
    {$ENDIF}
    procedure DoOnAppearanceChanged(Sender: TObject);
    procedure DoOnDarkStyleChanged(Sender: TObject; ADarkStyle: Boolean);
    procedure DoOnInternalFilterChanged(Sender: TObject);
    procedure SetControlAppearance(ADarkStyle: Boolean);
    procedure DrawExpression(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
    procedure DrawNot(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
//    procedure DrawCaseSensitive(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
    procedure DrawGroup(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
    procedure DrawArrow(AGraphics: TTMSFNCGraphics; ARect: TRectF; AFillColor: TTMSFNCGraphicsColor);
    procedure DrawItems(AGraphics: TTMSFNCGraphics; ARect: TRectF);
    procedure DrawAddDelete(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
    procedure DrawConnectionLine(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
    procedure DoAfterDrawPreview(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF); virtual;
    function GetDrawItemAtXY(AX: Single; AY: Single): TTMSFNCFilterDialogDrawItem; overload;
    function GetDrawItemAtXY(AX: Single; AY: Single; var APart: TTMSFNCFilterDialogDrawItemPart): TTMSFNCFilterDialogDrawItem; overload;
    {$IFDEF FMXLIB}
    procedure DoPreviewMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Single); virtual;
    procedure DoPreviewMouseDown(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Single); virtual;
    procedure DoPreviewMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Single); virtual;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure DoPreviewMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Integer); virtual;
    procedure DoPreviewMouseDown(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Integer); virtual;
    procedure DoPreviewMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Integer); virtual;
    {$ENDIF}
    procedure DoPreviewMouseLeave(Sender: TObject);
    procedure DoOnItemSelected(Sender: TObject; AText: string);
    procedure DoApplyClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); virtual;
    procedure DoOKClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); virtual;
    procedure DoCancelClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); virtual;
    procedure DoClearClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClear: Boolean); virtual;
    procedure DoButtonApplyClick(Sender:TObject);
    procedure DoButtonOKClick(Sender:TObject);
    procedure DoButtonCancelClick(Sender: TObject);
    procedure DoButtonClearClick(Sender:TObject);
    procedure ItemClick(ADrawItem: TTMSFNCFilterDialogDrawItem; APart: TTMSFNCFilterDialogDrawItemPart);
    procedure DoShowCustomEditor(ADrawItem: TTMSFNCFilterDialogDrawItem; AEditorProperties: TTMSFNCFilterDialogEditorProperties); virtual;
    procedure OpenCombo(AOpenParameters: TTMSFNCFilterDialogOpenControlParameters);
//    procedure GetCaseSensitive; virtual;
    procedure HandleEditorResult(AChange: Boolean = True);
    procedure DoGetFilterBuilder(var AFilterBuilder: TTMSFNCFilterBuilder); virtual;
    procedure DoGetFilterDataColmuns(AFilterBuilder: TTMSFNCFilterBuilder; ADataColumns: TTMSFNCFilterBuilderColumns); virtual;
    procedure DoClose; override;
    procedure FilterItemsChanged;
    procedure DoPreviewResize(Sender: TObject);
    procedure DoFormShow(Sender: TObject); override;
    procedure DoGetModalResult(AModalResult: TModalResult); override;
    procedure DoGetFormatSettings(var AFormatSettings: TFormatSettings); virtual;
    procedure DoOnFilterEditChange(Sender: TObject);
    {$IFDEF FMXLIB}
    procedure DoOnChangeComboKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    procedure DoOnChangeComboKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState); override;
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState); override;
    {$ENDIF}
    procedure DoOnFilterTimer(Sender: TObject);
    procedure DoOnChangeComboDropDownKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure DoOnChangeComboEditKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure DoOnChangeComboGetFormatSettings(Sender: TObject; var AFormatSettings: TFormatSettings);
    procedure DoOnCloseDropDown(Sender: TObject);
    procedure BuildDialog(AParent: TTMSFNCCustomDialogParent); override;
    procedure UpdateDrawItems;
    procedure UpdateExpressionEdit;
    procedure DoShowGroupEditorEvent(AGroup: TTMSFNCFilterBuilderGroup; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; AValues: TStringList; var AFixed: Boolean; var AShow: Boolean);
    procedure DoGetExpressionValueList(AColumn: TTMSFNCFilterBuilderColumn; AValues: TStringList); virtual;
    procedure DoShowExpressionEditorEvent(AExpression: TTMSFNCFilterBuilderExpression; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; AValues: TStringList; var AFixed: Boolean; var AShow: Boolean);
    procedure DoBeforeExecute; virtual;
    function GetTextForGroupOperator(AGroupOperator: TTMSFNCFilterBuilderGroupOperator): string;
    function GetTextForExpressionOperator(AExpressionOperator: TTMSFNCFilterBuilderExpressionOperator): string;
    function GroupOperatorFoundForText(AText: string; var AGroupOperator: TTMSFNCFilterBuilderGroupOperator): Boolean;
    function ExpressionOperatorFoundForText(AText: string; var AExpressionOperator: TTMSFNCFilterBuilderExpressionOperator): Boolean;
    property FilterBuilder: TTMSFNCFilterBuilder read FFilterBuilder write SetFilterBuilder;
    property FilterText: string read GetFilterText write SetFilterText;
    property DisplayFilterText: string read GetDisplayFilterText write SetFilterText;
    property Options: TTMSFNCFilterDialogOptions read FOptions write SetOptions;
    property Appearance: TTMSFNCFilterDialogAppearance read FAppearance write SetAppearance;
    property OnGetFilterBuilder: TTMSFNCFilterDialogGetFilterBuilder read FOnGetFilterBuilder write FOnGetFilterBuilder;
    property OnGetFilterBuilderDataColumns: TTMSFNCFilterDialogGetFilterBuilderColumns read FOnGetFilterBuilderDataColumns write FOnGetFilterBuilderDataColumns;
    property OnGetFormatSettings: TTMSFNCFilterDialogGetFormatSettings read FOnGetFormatSettings write FOnGetFormatSettings;
    property OnShowGroupEditor: TTMSFNCFilterDialogShowGroupEditor read FOnShowGroupEditor write FOnShowGroupEditor;
    property OnShowExpressionEditor: TTMSFNCFilterDialogShowExpressionEditor read FOnShowExpressionEditor write FOnShowExpressionEditor;
    property OnShowCustomEditor: TTMSFNCFilterDialogShowCustomEditor read FOnShowCustomEditor write FOnShowCustomEditor;
    property OnApplyButtonClicked: TTMSFNCFilterDialogButtonClicked read FOnApplyButtonClicked write FOnApplyButtonClicked;
    property OnOKButtonClicked: TTMSFNCFilterDialogButtonClicked read FOnOKButtonClicked write FOnOKButtonClicked;
    property OnCancelButtonClicked: TTMSFNCFilterDialogButtonClicked read FOnCancelButtonClicked write FOnCancelButtonClicked;
    property OnClearButtonClicked: TTMSFNCFilterDialogButtonClearClicked read FOnClearButtonClicked write FOnClearButtonClicked;
    property OnGetExpressionValues: TTMSFNCFilterDialogGetExpressionValues read FOnGetExpressionValues write FOnGetExpressionValues;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil; AModal: Boolean = True); override;
    {$ELSE}
    function Execute(AModal: Boolean = True): TModalResult; override;
    {$ENDIF}
    function ValidateFilterRow(AInputRow: TTMSFNCFilterValidateInputRow): Boolean;
    function ValidateFilterArray(AInputArray: TTMSFNCFilterValidateInputArray): TTMSFNCFilterValidateOutputArray;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWebDesktop)]
  {$ENDIF}
  TTMSFNCFilterDialog = class(TTMSFNCCustomFilterDialog)
//  protected
//    procedure RegisterRuntimeClasses; override;
  public
    constructor Create(AOwner: TComponent); override;
    property FilterBuilder;
  published
    property FilterText;
    property DisplayFilterText;
    property Options;
    property Appearance;
    property OnClose;
    property OnGetFilterBuilder;
    property OnGetFilterBuilderDataColumns;
    property OnGetFormatSettings;
    property OnShowGroupEditor;
    property OnShowExpressionEditor;
    property OnShowCustomEditor;
    property OnApplyButtonClicked;
    property OnOKButtonClicked;
    property OnCancelButtonClicked;
    property OnClearButtonClicked;
  end;

  TTMSFNCDataSetFilterDialogAddColumn = procedure(Sender: TObject; AField: TField; var AColumnProperties: TTMSFNCFilterBuilderColumnProperties; var AAdd: Boolean) of object;
  TTMSFNCDataSetFilterDialogColumnAdded = procedure(Sender: TObject; AColumn: TTMSFNCFilterBuilderColumn) of object;

  TTMSFNCCustomDataSetFilterDialog = class(TTMSFNCCustomFilterDialog)
  private
    FDataSet: TDataSet;
    FOnBeforeAddColumn: TTMSFNCDataSetFilterDialogAddColumn;
    FOnAfterAddColumn: TTMSFNCDataSetFilterDialogColumnAdded;
    procedure SetDataSet(const Value: TDataSet);
    function GetFilterText: string; override;
    procedure SetFilterText(const Value: string); override;
  protected
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure AddDataSetColumns;
    procedure DoBeforeExecute; override;
    procedure DoGetModalResult(AModalResult: TModalResult); override;
    procedure DoBeforeAddColumn(AField: TField; var AColumnProperties: TTMSFNCFilterBuilderColumnProperties; var AAdd: Boolean); virtual;
    procedure DoAfterAddColumn(AColumn: TTMSFNCFilterBuilderColumn); virtual;
    procedure DoApplyClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); override;
    procedure DoOKClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); override;
    procedure DoCancelClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean); override;
    procedure DoGetExpressionValueList(AColumn: TTMSFNCFilterBuilderColumn; AValues: TStringList); override;
    property DataSet: TDataSet read FDataSet write SetDataSet;
    property OnBeforeAddColumn: TTMSFNCDataSetFilterDialogAddColumn read FOnBeforeAddColumn write FOnBeforeAddColumn;
    property OnAfterAddColumn: TTMSFNCDataSetFilterDialogColumnAdded read FOnAfterAddColumn write FOnAfterAddColumn;
  public
    constructor Create(AOwner: TComponent); override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCDataSetFilterDialog = class(TTMSFNCCustomDataSetFilterDialog)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property FilterText;
    property DataSet;
    property Options;
    property Appearance;
    property OnClose;
    property OnGetFormatSettings;
    property OnShowGroupEditor;
    property OnShowExpressionEditor;
    property OnShowCustomEditor;
    property OnApplyButtonClicked;
    property OnOKButtonClicked;
    property OnCancelButtonClicked;
    property OnClearButtonClicked;
    property OnBeforeAddColumn;
    property OnAfterAddColumn;
    property OnGetExpressionValues;
  end;

implementation

uses
  {$IFDEF FMXLIB}
  FMX.Platform,
  {$ENDIF}
  WEBLib.TMSFNCEdit,
  Rtti, Math, WEBLib.Graphics, WEBLib.TMSFNCEditorsTools, WEBLib.TMSFNCUtils, DateUtils;

type
  TFBOpen = class(TTMSFNCFilterBuilder);
  TFBGroupOpen = class(TTMSFNCFilterBuilderGroup);
  TTMSFNCCustomDialogEx = class(TTMSFNCCustomDialog);
  TCustomFormOpen = class(TCustomForm);
  {$IFDEF VCLLIB}
  TTMSFNCEditorDropDownEditOpen = class(TTMSFNCEditorDropDownEdit);
  {$ENDIF}

{$R TMSFNCFilterDialog.res}

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  Result := AText;
  {$ENDIF}
end;

function ContainsLetters(AText: string): Boolean;
var
//  I: Integer;
//  found: Boolean;
  c: Char;
begin
//  found := False;
//  {$IFDEF ZEROSTRINGINDEX}
//  I := 0;
//  {$ELSE}
//  I := 1;
//  {$ENDIF}
//  while not found and (I < Length(AText)) do
//  begin
//    found := CharIsLetter(AText[I]);
//    Inc(I);
//  end;

  Result := False;

  for c in AText do
  begin
    if CharIsLetter(c) then
    begin
      Result := True;
      Exit;
    end;
  end;
end;

{ TTMSFNCDataSetFilterDialog }

procedure TTMSFNCDataSetFilterDialog.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCDataSetFilterDialog);
end;

{ TTMSFNCCustomFilterDialog }

procedure TTMSFNCCustomFilterDialog.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCCustomFilterDialog) then
  begin
    FOptions.Assign((Source as TTMSFNCCustomFilterDialog).Options);
    FAppearance.Assign((Source as TTMSFNCCustomFilterDialog).Appearance);
  end
  else
    inherited;
end;

procedure TTMSFNCCustomFilterDialog.BuildDialog(AParent: TTMSFNCCustomDialogParent);
begin
  inherited;

  if AParent is TCustomForm then
  begin
    {$IFDEF FMXLIB}
    TCustomFormOpen(AParent).FormStyle := TFormStyle.StayOnTop;
    TCustomFormOpen(AParent).Position := TFormPosition.MainFormCenter;
    {$ELSE}
    TCustomFormOpen(AParent).FormStyle := fsStayOnTop;
    {$IFDEF VCLLIB}
    TCustomFormOpen(AParent).Position := poMainFormCenter;
    TCustomFormOpen(AParent).KeyPreview := False;
    {$ENDIF}
    {$ENDIF}
  end;

  FTopPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FTopPanel.Align := TAlignLayout.Top;
  FTopPanel.PanelPosition := eppTop;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  FTopPanel.PanelPosition := eppCenter;
  FTopPanel.Align := alTop;
  {$ENDIF}
  FTopPanel.Parent := AParent;

  FTopPanel.Height := 37;

  FExpressionEdit := TEdit.Create(FTopPanel);
  FExpressionEdit.Parent := FTopPanel;
  FExpressionEdit.Text := FilterBuilder.DisplayFilterText;
  {$IFDEF FMXLIB}
  FExpressionEdit.Align := TAlignLayout.Client;
  FExpressionEdit.OnChangeTracking := DoOnFilterEditChange;
  {$ELSE}
  FExpressionEdit.Align := alTop;
  FExpressionEdit.AlignWithMargins := True;
  FExpressionEdit.OnChange := @DoOnFilterEditChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FExpressionEdit.Align := alClient;
  FExpressionEdit.AlignWithMargins := True;
  {$ENDIF}

  FExpressionEdit.Margins.Right := 5;
  FExpressionEdit.Margins.Top := 5;
  FExpressionEdit.Margins.Bottom := 5;
  FExpressionEdit.Margins.Left := 5;

  if fdbClear in FOptions.Buttons then
  begin
    FButtonClear := TTMSFNCEditorButton.Create(FTopPanel);
    FButtonClear.Parent := FTopPanel;
    FButtonClear.Text := FOptions.UILanguage.Clear;
    {$IFDEF FMXLIB}
    FButtonClear.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    FButtonClear.Align := alRight;
    FButtonClear.Left := 99;
    {$IFDEF VCLWEBLIB}
    FButtonClear.AlignWithMargins := True;
    {$ENDIF}
    {$ENDIF}
    {$IFDEF LCLLIB}
    FButtonClear.BorderSpacing.Right := 5;
    FButtonClear.BorderSpacing.Top := 5;
    FButtonClear.BorderSpacing.Bottom := 5;
    FButtonClear.BorderSpacing.Left := 5;
    {$ENDIF}
    {$IFNDEF LCLLIB}
    FButtonClear.Margins.Right := 5;
    FButtonClear.Margins.Top := 5;
    FButtonClear.Margins.Bottom := 5;
    FButtonClear.Margins.Left := 5;
    {$ENDIF}
    FButtonClear.OnClick := DoButtonClearClick;
  end;

  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Client;
  FPanel.PanelPosition := eppCenter;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alClient;
  {$ENDIF}
  FPanel.Parent := AParent;
  {$IFDEF FMXLIB}
  FVScrlBox := TVertScrollBox.Create(FPanel);
  FVScrlBox.Align := TAlignLayout.Client;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  FVScrlBox := TScrollBox.Create(FPanel);
  FVScrlBox.Align := alClient;
  FVScrlBox.Top := 0;
  {$IFDEF LCLLIB}
  FVScrlBox.HorzScrollBar.Visible:= False;
  {$ENDIF}
  {$ENDIF}
  FVScrlBox.Parent := FPanel;

  FPreview := TTMSFNCFilterPreview.Create(FVScrlBox);
  FPreview.Parent := FVScrlBox;
  FPreview.Dialog := Self;
  {$IFDEF FMXLIB}
  FPreview.Align := TAlignLayout.Top;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  FPreview.Align := alClient;
  {$ENDIF}
  {$IFDEF WEBLIB}
  FPreview.DisableBackground;
  {$ENDIF}
  FPreview.DisableStroke;
  FPreview.ShowHint := True;

  FChangeCombo := TTMSFNCEditorDropDownEdit.Create(FPreview);
  FChangeCombo.Parent := FPreview;
  {$IFDEF FMXLIB}
  FChangeCombo.Position.X := -100;
  FChangeCombo.Position.Y := -100;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChangeCombo.Left := -100;
  FChangeCombo.Top := -100;
  {$ENDIF}
  FChangeCombo.Appearance.TransparentEdit := True;
  FChangeCombo.OnKeyDown := @DoOnChangeComboKeyDown;
  FChangeCombo.OnDropDownKeyDown := DoOnChangeComboDropDownKeyDown;
  FChangeCombo.OnEditKeyDown := DoOnChangeComboEditKeyDown;
  FChangeCombo.OnDropDownClosed := DoOnCloseDropDown;
  FChangeCombo.OnGetFormatSettings := DoOnChangeComboGetFormatSettings;

  FBottomPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FBottomPanel.Align := TAlignLayout.Bottom;
  FBottomPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF VCLWEBLIB}
  FBottomPanel.PanelPosition := eppCenter;
  FBottomPanel.Align := alBottom;
  {$ENDIF}
  FBottomPanel.Parent := AParent;

  FBottomPanel.Height := 37;

  if fdbCancel in FOptions.Buttons then
  begin
    FButtonCancel := TTMSFNCEditorButton.Create(FBottomPanel);
  //  FButtonCancel.ModalResult := mrCancel;
    FButtonCancel.Parent := FBottomPanel;
    FButtonCancel.Text := FOptions.UILanguage.Cancel;
    {$IFDEF FMXLIB}
    FButtonCancel.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    FButtonCancel.Align := alRight;
    FButtonCancel.Left := 99;
    FButtonCancel.AlignWithMargins := True;
    {$ENDIF}
    FButtonCancel.Margins.Right := 5;
    FButtonCancel.Margins.Top := 5;
    FButtonCancel.Margins.Bottom := 5;
    FButtonCancel.Margins.Left := 0;
    FButtonCancel.OnClick := DoButtonCancelClick;
  end;

  if fdbApply in FOptions.Buttons then
  begin
    FButtonApply := TTMSFNCEditorButton.Create(FBottomPanel);
  //  FButtonApply.ModalResult := mrOk;
    FButtonApply.Parent := FBottomPanel;
    FButtonApply.Text := FOptions.UILanguage.Apply;
    {$IFDEF FMXLIB}
    if fdbOk in FOptions.Buttons then
      FButtonApply.Align := TAlignLayout.Left
    else
      FButtonApply.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    if fdbOk in FOptions.Buttons then
      FButtonApply.Align := alLeft
    else
      FButtonApply.Align := alRight;
    FButtonApply.Left := 99;
    FButtonApply.AlignWithMargins := True;
    {$ENDIF}
    FButtonApply.Margins.Right := 5;
    FButtonApply.Margins.Top := 5;
    FButtonApply.Margins.Bottom := 5;
    FButtonApply.Margins.Left := 5;
    FButtonApply.OnClick := DoButtonApplyClick;
  end;

  if fdbOk in FOptions.Buttons then
  begin
    FButtonOk := TTMSFNCEditorButton.Create(FBottomPanel);
  //  FButtonOk.ModalResult := mrOk;
    FButtonOk.Parent := FBottomPanel;
    FButtonOk.Text := FOptions.UILanguage.Ok;
    {$IFDEF FMXLIB}
    FButtonOk.Align := TAlignLayout.Right;
    {$ENDIF}
    {$IFDEF VCLWEBLIB}
    FButtonOk.Align := alRight;
    FButtonOk.Left := 130;
    FButtonOk.AlignWithMargins := True;
    {$ENDIF}
    FButtonOk.Margins.Right := 5;
    FButtonOk.Margins.Top := 5;
    FButtonOk.Margins.Bottom := 5;
    FButtonOk.Margins.Left := 5;
    FButtonOk.OnClick := DoButtonOkClick;
  end;

  FPreview.OnResize := DoPreviewResize;
  FPreview.OnAfterDraw := DoAfterDrawPreview;
  FPreview.OnMouseMove := DoPreviewMouseMove;
  FPreview.OnMouseUp := DoPreviewMouseUp;
  FPreview.OnMouseDown := DoPreviewMouseDown;
  FPreview.OnMouseLeave := DoPreviewMouseLeave;

  UpdateDrawItems;
  ResetChangeControls;

  DoOnDarkStyleChanged(Self,FAppearance.DarkStyleControls);
end;

{$IFDEF VCLLIB}
procedure TTMSFNCCustomFilterDialog.ChangeDPIScale(M: Integer; D: Integer);
begin
  inherited;
  if Assigned(FAppearance) then
    FAppearance.ChangeDPIScale(M, D);

  if (M <> D) and (M > 1) and (D > 1) then
  begin
    FDefaultDropDownHeight := TTMSFNCUtils.MulDivInt(FDefaultDropDownHeight, M, D);
    if Assigned(FChangeCombo) then
      TTMSFNCEditorDropDownEditOpen(FChangeCombo).ChangeScale(M, D);
    UpdateDrawItems;
  end;
end;
{$ENDIF}

constructor TTMSFNCCustomFilterDialog.Create(AOwner: TComponent);
begin
  inherited;
  DestroyForm := False;

  DialogWidth := 470;

  FDefaultDropDownHeight := 150;

  Sizeable := True;

  AllowReturnKeyClose := True;

  FFilterTimer := TTimer.Create(nil);
  FFilterTimer.OnTimer := DoOnFilterTimer;
  FFilterTimer.Interval := 50;
  FFilterTimer.Enabled := False;

  FOriginalFilterBuilder := TTMSFNCFilterBuilder.Create;
  TFBGroupOpen(FOriginalFilterBuilder.Filter).OnInternalChanged := DoOnInternalFilterChanged;

  FFilterBuilder := FOriginalFilterBuilder;

  FOptions := TTMSFNCFilterDialogOptions.Create(Self);
  FAppearance := TTMSFNCFilterDialogAppearance.Create(Self);
  FAppearance.OnInternalChanged := DoOnAppearanceChanged;

  AllowReturnKeyClose := False;

  FDrawItems := TTMSFNCFilterDialogDrawItemList.Create;

  Caption := FOptions.UILanguage.Caption;

  FMouseDown := False;
  FMouseDrag := False;
  ResetHoveredItem;
end;

destructor TTMSFNCCustomFilterDialog.Destroy;
begin
  FFilterTimer.Free;
  FDrawItems.Free;
  FOriginalFilterBuilder.Free;
  FOptions.Free;
  FAppearance.Free;
  inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoAfterDrawPreview(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF);
begin
  DrawItems(AGraphics, ARect);
end;

procedure TTMSFNCCustomFilterDialog.DoApplyClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
begin
  if Assigned(FOnApplyButtonClicked) then
    FOnApplyButtonClicked(Self, AFilterBuilder, AClose)
end;

procedure TTMSFNCCustomFilterDialog.DoBeforeExecute;
begin
  DoGetFilterBuilder(FFilterBuilder);

  DoGetFilterDataColmuns(FFilterBuilder, FFilterBuilder.DataColumns);

  if FFilterBuilder.DisplayFilterText <> FFilterText then
    SetFilterText(FFilterText);
end;

procedure TTMSFNCCustomFilterDialog.DoButtonApplyClick(Sender: TObject);
var
  cl: Boolean;
begin
  if FEditorOpen and Assigned(FChangeCombo) then
    HandleEditorResult(FChangeCombo.DropDownType = ddetEdit);

  FFilterText := FFilterBuilder.DisplayFilterText;

  cl := not (fdbOk in FOptions.Buttons);
  DoApplyClicked(FFilterBuilder, cl);

  if cl then
  begin
    Form.ModalResult := mrOk;
    if not FIsModal then
      Form.Close;
  end
  else
    FCopyFilterText := FFilterText;
end;

procedure TTMSFNCCustomFilterDialog.DoButtonCancelClick(Sender: TObject);
var
  cl: Boolean;
begin
  if FEditorOpen and Assigned(FChangeCombo) then
    HandleEditorResult(False);

  cl := True;
  DoCancelClicked(FFilterBuilder, cl);

  if cl then
  begin
    Form.ModalResult := mrCancel;
    if not FIsModal then
      Form.Close;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DoButtonClearClick(Sender: TObject);
var
  cl: Boolean;
begin
  cl := True;
  DoClearClicked(FFilterBuilder, cl);

  if cl then
  begin
    FFilterBuilder.ClearFilter;
    FExpressionEdit.Text := '';
    UpdateDrawItems;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DoButtonOKClick(Sender: TObject);
var
  cl: Boolean;
begin
  if FEditorOpen and Assigned(FChangeCombo) then
    HandleEditorResult(FChangeCombo.DropDownType = ddetEdit);
  FFilterText := FFilterBuilder.DisplayFilterText;
  cl := True;
  DoOKClicked(FFilterBuilder, cl);

  if cl then
  begin
    Form.ModalResult := mrOk;
    if not FIsModal then
      Form.Close;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DoCancelClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
begin
  if Assigned(FOnCancelButtonClicked) then
    FOnCancelButtonClicked(Self, AFilterBuilder, AClose);
end;

procedure TTMSFNCCustomFilterDialog.DoClearClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClear: Boolean);
begin
  if Assigned(FOnClearButtonClicked) then
    FOnClearButtonClicked(Self, AFilterBuilder, AClear);
end;

procedure TTMSFNCCustomFilterDialog.DoClose;
begin
  if Assigned(FChangeCombo) then
    FChangeCombo.CloseDropDown;

  if Form.ModalResult <> mrOk then
  begin
    FFilterBuilder.FilterText := FCopyFilterText;
    FFilterText := FCopyFilterText;
  end;

  FDialogOpen := False;
  inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoOnFilterEditChange(Sender: TObject);
begin
  FFilterTime := 0;
  FFilterTimer.Enabled := True;
end;

procedure TTMSFNCCustomFilterDialog.DoOnFilterTimer(Sender: TObject);
begin
  if (FFilterTime > 20) then
  begin
    FFilterTime := 0;
    FFilterTimer.Enabled := False;

    if (FFilterBuilder.DisplayFilterText <> FExpressionEdit.Text) then
    begin
      if not FFilterBuilder.ParseExpression(FExpressionEdit.Text) then
        {$IFDEF FMXLIB}
        FExpressionEdit.FontColor := gcRed
        {$ENDIF}
        {$IFNDEF FMXLIB}
        FExpressionEdit.Font.Color := gcRed
        {$ENDIF}
      else
      begin
        {$IFDEF FMXLIB}
        FExpressionEdit.FontColor := GetEditorDefaultFontColor;
        {$ENDIF}
        {$IFNDEF FMXLIB}
        FExpressionEdit.Font.Color := GetEditorDefaultFontColor;
        {$ENDIF}
        UpdateDrawItems;
      end;
    end;
  end
  else
    Inc(FFilterTime);
end;

procedure TTMSFNCCustomFilterDialog.DoOnInternalFilterBuilderChanged(Sender: TObject);
begin
  if not IsOpen then
  begin
    FFilterText := FFilterBuilder.DisplayFilterText;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DoOnInternalFilterChanged(Sender: TObject);
begin
  FFilterText := FilterBuilder.DisplayFilterText;
end;

procedure TTMSFNCCustomFilterDialog.DoOnItemSelected(Sender: TObject; AText: string);
begin
  HandleEditorResult(True);
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoOnChangeComboKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
{$IFDEF VCLWEBLIB}
procedure TTMSFNCCustomFilterDialog.DoOnChangeComboKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
begin
  if Key in [KEY_ESCAPE, KEY_RETURN] then
  begin
    if Key = KEY_ESCAPE then
      HandleEditorResult(False)
    else if Key = KEY_RETURN then
      HandleEditorResult(True);

    Key := 0;
  end;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  if (Key = KEY_RETURN) then
    DoButtonApplyClick(Self);

  inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoFormShow(Sender: TObject);
begin
  inherited;
  UpdateDrawItems;

  if Assigned(FPreview) and FPreview.Visible then
    FPreview.SetFocus;
end;

procedure TTMSFNCCustomFilterDialog.DoGetExpressionValueList(AColumn: TTMSFNCFilterBuilderColumn; AValues: TStringList);
begin
  if Assigned(FOnGetExpressionValues) then
    FOnGetExpressionValues(Self, AColumn, AValues);
end;

procedure TTMSFNCCustomFilterDialog.DoGetFilterBuilder(var AFilterBuilder: TTMSFNCFilterBuilder);
begin
  if Assigned(FOnGetFilterBuilder) then
    FOnGetFilterBuilder(Self, AFilterBuilder);
end;

procedure TTMSFNCCustomFilterDialog.DoGetFormatSettings(var AFormatSettings: TFormatSettings);
begin
  if Assigned(FOnGetFormatSettings) then
    FOnGetFormatSettings(Self, AFormatSettings);
end;

procedure TTMSFNCCustomFilterDialog.DoGetModalResult(AModalResult: TModalResult);
begin
  inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoInternalChanged;
begin
  FilterItemsChanged;
end;

procedure TTMSFNCCustomFilterDialog.DoOKClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
begin
  if Assigned(OnOKButtonClicked) then
    OnOKButtonClicked(Self, AFilterBuilder, AClose);
end;

procedure TTMSFNCCustomFilterDialog.DoOnAppearanceChanged(Sender: TObject);
begin
  UpdateDrawItems;
end;

procedure TTMSFNCCustomFilterDialog.DoOnChangeComboDropDownKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  if Key = KEY_ESCAPE then
    HandleEditorResult(False)
  else if Key = KEY_RETURN then
  begin
    HandleEditorResult(True);
    Key := 0;
  end
  else
    inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoOnChangeComboEditKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
begin
  if Key = KEY_ESCAPE then
    HandleEditorResult(False)
  else if Key = KEY_RETURN then
  begin
    HandleEditorResult(True);
    Key := 0;
  end
  else
    inherited;
end;

procedure TTMSFNCCustomFilterDialog.DoOnChangeComboGetFormatSettings(Sender: TObject; var AFormatSettings: TFormatSettings);
begin
  AFormatSettings := FFilterBuilder.GetFormatSettings;
  DoGetFormatSettings(AFormatSettings);
end;

procedure TTMSFNCCustomFilterDialog.DoOnCloseDropDown(Sender: TObject);
var
  setResult: Boolean;
begin
  if FEditorOpen and (FEditorIndex >= 0) then
  begin
    case FChangeCombo.DropDownType of
      ddetEdit: setResult := True;
      ddetComboBox: setResult := (FChangeCombo.ItemIndex >= 0);
      ddetComboEdit: setResult := True;
      ddetDatePicker, ddetTimePicker: setResult := True;
      else
        setResult := False;
    end;
    HandleEditorResult(setResult);
  end;
  FPreview.Invalidate;
end;

procedure TTMSFNCCustomFilterDialog.DoOnDarkStyleChanged(Sender: TObject; ADarkStyle: Boolean);
begin
  if ADarkStyle then
    SetTMSFNCDesignerTheme(edtDark)
  else
    SetTMSFNCDesignerTheme(edtLight);

  SetControlAppearance(ADarkStyle);
end;

procedure TTMSFNCCustomFilterDialog.DoPreviewMouseLeave(Sender: TObject);
begin
  ResetHoveredItem;
  FPreview.Invalidate;
end;


{$IFDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseDown(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Single);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseDown(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Integer);
{$ENDIF}
begin
  if FEditorOpen then
  begin
    HandleEditorResult;
  end
  else
  begin
    FMouseDown := True;
  end;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Single);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseMove(Sender: TObject; Shift: TShiftState; X, Y: Integer);
{$ENDIF}
var
  hit: TTMSFNCFilterDialogDrawItem;
  hp: TTMSFNCFilterDialogDrawItemPart;
  cur: TCursor;
begin
  cur := crDefault;

  if not FMouseDown then
  begin
    hit := GetDrawItemAtXY(X,Y, hp);

    if Assigned(hit) then
    begin
      if hp <> ddipNone then
        cur := crHandPoint;
      if (FHoveredItemIndex <> hit.Index) or (FHoverItemPart <> hp) then
      begin
        FHoverItemPart := hp;
        FHoveredItemIndex := hit.Index;
        FPreview.Invalidate;
      end;
    end
    else if FHoveredItemIndex >= 0 then
    begin
      ResetHoveredItem;
      FPreview.Invalidate;
    end;
//  end
//  else
//  begin
//    FMouseDrag := True;
//    cur := crDrag;
  end;

  if cur <> FPreview.Cursor then
    FPreview.Cursor := cur;
end;

{$IFDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Single);
{$ENDIF}
{$IFNDEF FMXLIB}
procedure TTMSFNCCustomFilterDialog.DoPreviewMouseUp(Sender: TObject; Button: TMouseButton; Shift: TShiftState; X, Y: Integer);
{$ENDIF}
var
  hit: TTMSFNCFilterDialogDrawItem;
  hp: TTMSFNCFilterDialogDrawItemPart;
begin
  hit := GetDrawItemAtXY(X,Y, hp);

  if Assigned(hit) and (hp <> ddipNone) then
  begin
    ItemClick(hit, hp);
  end;

  FMouseDown := False;
end;

procedure TTMSFNCCustomFilterDialog.DoPreviewResize(Sender: TObject);
begin
  inherited;
  UpdateDrawItems;
end;

procedure TTMSFNCCustomFilterDialog.DoGetFilterDataColmuns(AFilterBuilder: TTMSFNCFilterBuilder; ADataColumns: TTMSFNCFilterBuilderColumns);
begin
  if Assigned(FOnGetFilterBuilderDataColumns) then
    FOnGetFilterBuilderDataColumns(Self, AFilterBuilder, ADataColumns);
end;

procedure TTMSFNCCustomFilterDialog.DoShowCustomEditor(ADrawItem: TTMSFNCFilterDialogDrawItem; AEditorProperties: TTMSFNCFilterDialogEditorProperties);
begin
  if Assigned(FOnShowCustomEditor) then
    FOnShowCustomEditor(Self, ADrawItem, AEditorProperties);
end;

procedure TTMSFNCCustomFilterDialog.DoShowExpressionEditorEvent(AExpression: TTMSFNCFilterBuilderExpression; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; AValues: TStringList; var AFixed, AShow: Boolean);
begin
  if Assigned(FOnShowExpressionEditor) then
    FOnShowExpressionEditor(Self, AExpression, AEditorProperties, AValues, AFixed, AShow);
end;

procedure TTMSFNCCustomFilterDialog.DoShowGroupEditorEvent(AGroup: TTMSFNCFilterBuilderGroup; var AEditorProperties: TTMSFNCFilterDialogEditorProperties; AValues: TStringList; var AFixed, AShow: Boolean);
begin
  if Assigned(FOnShowGroupEditor) then
    FOnShowGroupEditor(Self, AGroup, AEditorProperties, AValues, AFixed, AShow);
end;

procedure TTMSFNCCustomFilterDialog.DrawExpression(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
var
  hvd: Boolean;
begin
  hvd := ADrawItem.Index = FHoveredItemIndex;

  AGraphics.Stroke.Kind := gskNone;

  DrawNot(AGraphics, ADrawItem);

  if hvd then
  begin
    AGraphics.Fill.Assign(FAppearance.HoverFill);
    AGraphics.Stroke.Color := gcAzure;

    if AGraphics.Fill.Color = gcNull then
    begin
      AGraphics.Fill.Color := FAppearance.ThemeColor;
      AGraphics.Font.Color := FAppearance.ThemeFontColor;
    end;

    AGraphics.DrawRectangle(RectF(ADrawItem.ColumnNameRect.Left - 6, ADrawItem.Rect.Top, ADrawItem.Rect.Right, ADrawItem.Rect.Bottom));
  end;

  if hvd and (FHoverItemPart = ddipOperator) then
  begin
    AGraphics.Stroke.Kind := gskSolid;
    AGraphics.Stroke.Color := gcLightblue;
  end
  else
    AGraphics.Stroke.Kind := gskNone;

  AGraphics.Fill.Assign(FAppearance.ExpressionOperatorFill);
  AGraphics.Font.Assign(FAppearance.ExpressionOperatorFont);

  if hvd and (FHoverItemPart = ddipName) then
  begin
    AGraphics.Stroke.Kind := gskSolid;
    AGraphics.Stroke.Color := gcLightblue;
  end
  else
    AGraphics.Stroke.Kind := gskNone;

  AGraphics.Fill.Assign(FAppearance.ExpressionColumnFill);
  AGraphics.Font.Assign(FAppearance.ExpressionColumnFont);

  if AGraphics.Fill.Color = gcNull then
  begin
    AGraphics.Fill.Color := FAppearance.ThemeColor;
    AGraphics.Font.Color := FAppearance.ThemeFontColor;
  end;

  AGraphics.DrawRoundRectangle(ADrawItem.ColumnNameRect,ADrawItem.Rounding);

  if not (FEditorOpen and (FEditorIndex = ADrawItem.Index) and (FEditorPart = ddipName)) then
    AGraphics.DrawText(ADrawItem.ColumnNameTextRect,ADrawItem.ColumnNameText);

  DrawArrow(AGraphics, ADrawItem.ColumnNameArrowRect, AGraphics.Font.Color);

  if hvd and (FHoverItemPart = ddipOperator) then
  begin
    AGraphics.Stroke.Kind := gskSolid;
    AGraphics.Stroke.Color := gcLightblue;
  end
  else
    AGraphics.Stroke.Kind := gskNone;

  AGraphics.Fill.Assign(FAppearance.ExpressionOperatorFill);
  AGraphics.Font.Assign(FAppearance.ExpressionOperatorFont);

  if AGraphics.Fill.Color = gcNull then
  begin
    AGraphics.Fill.Color := FAppearance.ThemeColor;
    AGraphics.Font.Color := FAppearance.ThemeFontColor;
  end;

  AGraphics.DrawRoundRectangle(ADrawItem.OperatorRect,ADrawItem.Rounding);

  if not (FEditorOpen and (FEditorIndex = ADrawItem.Index) and (FEditorPart = ddipOperator)) then
    AGraphics.DrawText(ADrawItem.OperatorTextRect,ADrawItem.OperatorText);

  DrawArrow(AGraphics, ADrawItem.OperatorArrowRect, AGraphics.Font.Color);

  if hvd and (FHoverItemPart = ddipValue) then
  begin
    AGraphics.Stroke.Kind := gskSolid;
    AGraphics.Stroke.Color := gcLightblue;
  end
  else
    AGraphics.Stroke.Kind := gskNone;

  AGraphics.Fill.Assign(FAppearance.ExpressionValueFill);
  AGraphics.Font.Assign(FAppearance.ExpressionValueFont);

  if AGraphics.Fill.Color = gcNull then
  begin
    AGraphics.Fill.Color := FAppearance.ThemeColor;
    AGraphics.Font.Color := FAppearance.ThemeFontColor;
  end;

  AGraphics.DrawRoundRectangle(ADrawItem.ValueRect,ADrawItem.Rounding);

  if not (FEditorOpen and (FEditorIndex = ADrawItem.Index) and (FEditorPart = ddipValue)) then
    AGraphics.DrawText(ADrawItem.ValueTextRect,ADrawItem.ValueText);

  DrawArrow(AGraphics, ADrawItem.ValueArrowRect, AGraphics.Font.Color);

  if (ADrawItem.FExtraValueRect.Left >= 0) or (ADrawItem.FExtraValueRect.Right >= 0) then
  begin
    if hvd and (FHoverItemPart = ddipExtraValue) then
    begin
      AGraphics.Stroke.Kind := gskSolid;
      AGraphics.Stroke.Color := gcLightblue;
    end
    else
      AGraphics.Stroke.Kind := gskNone;

    AGraphics.Fill.Assign(FAppearance.ExpressionValueFill);
    AGraphics.Font.Assign(FAppearance.ExpressionValueFont);

    if AGraphics.Fill.Color = gcNull then
      AGraphics.Fill.Color := FAppearance.ThemeColor;

    AGraphics.DrawRoundRectangle(ADrawItem.ExtraValueRect, ADrawItem.Rounding);

    if not (FEditorOpen and (FEditorIndex = ADrawItem.Index) and (FEditorPart = ddipExtraValue)) then
      AGraphics.DrawText(ADrawItem.ExtraValueTextRect, ADrawItem.ExtraValueText);

    DrawArrow(AGraphics, ADrawItem.ExtraValueArrowRect, AGraphics.Font.Color);
  end;

//  DrawCaseSensitive(AGraphics, ADrawItem);

  DrawAddDelete(AGraphics, ADrawItem);
  DrawConnectionLine(AGraphics, ADrawItem);
end;

procedure TTMSFNCCustomFilterDialog.DrawGroup(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
begin
  AGraphics.Stroke.Kind := gskNone;
  if (ADrawItem.Index = FHoveredItemIndex) then
  begin
    AGraphics.Fill.Assign(FAppearance.HoverFill);

    AGraphics.DrawRectangle(ADrawItem.Rect);
    if (FHoverItemPart = ddipOperator) then
    begin
      AGraphics.Stroke.Assign(FAppearance.HoverFill);
      AGraphics.Fill.Kind := gfkNone;
    end;
  end;

  if Assigned(FAppearance) then
  begin
    AGraphics.Fill.Assign(FAppearance.GroupFill);
    AGraphics.Font.Assign(FAppearance.GroupFont);

    if AGraphics.Fill.Color = gcNull then
    begin
      AGraphics.Fill.Color := FAppearance.ThemeColor;
      AGraphics.Font.Color := FAppearance.ThemeFontColor;
    end;
  end;

  AGraphics.DrawRoundRectangle(ADrawItem.OperatorRect,ADrawItem.Rounding);

  if not (FEditorOpen and (FEditorIndex = ADrawItem.Index) and (FEditorPart = ddipOperator)) then
  AGraphics.DrawText(ADrawItem.OperatorTextRect,ADrawItem.OperatorText);

  DrawArrow(AGraphics, ADrawItem.OperatorArrowRect, AGraphics.Font.Color);
  DrawAddDelete(AGraphics, ADrawItem);
  DrawConnectionLine(AGraphics, ADrawItem);
end;

procedure TTMSFNCCustomFilterDialog.DrawAddDelete(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
var
  bmpAdd, bmpDel: TTMSFNCBitmap;
  {$IFNDEF WEBLIB}
  bsAdd, bsDel: TBytesStream;
  {$ENDIF}
begin
  AGraphics.Fill.Kind := gfkNone;
  AGraphics.Stroke.Kind := gskSolid;

  if Assigned(FAppearance) then
  begin
    AGraphics.Stroke.Color := FAppearance.GroupFill.Color;
    AGraphics.Font.Color := FAppearance.GroupFill.Color;
  end;

  {$IFDEF WEBLIB}
  bmpDel := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCREMOVEBITMAP, HInstance));
  bmpAdd := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCADDBITMAP, HInstance));
  {$ENDIF}
  {$IFNDEF WEBLIB}
  bsAdd := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCADDBITMAP));
  bsDel := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCREMOVEBITMAP));
  try
    bmpDel := TTMSFNCBitmap.CreateFromStream(bsDel);
    bmpAdd := TTMSFNCBitmap.CreateFromStream(bsAdd);
  finally
    bsAdd.Free;
    bsDel.Free;
  end;
  {$ENDIF};

  try
    {$IFNDEF WEBLIB}
    if bmpAdd.HasSVG then
      bmpAdd.SVG.CustomFillColor := FAppearance.ThemeColor;
    if bmpDel.HasSVG then
      bmpDel.SVG.CustomFillColor := FAppearance.ThemeColor;
    {$ENDIF};
    if (ADrawItem.DeleteRect.Left >= 0) or (ADrawItem.DeleteRect.Right >= 0) then
      AGraphics.DrawBitmap(ADrawItem.DeleteRect, bmpDel);
    if (ADrawItem.AddRect.Left >= 0) or (ADrawItem.AddRect.Right >= 0) then
      AGraphics.DrawBitmap(ADrawItem.AddRect, bmpAdd);
  finally
    bmpAdd.Free;
    bmpDel.Free;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DrawArrow(AGraphics: TTMSFNCGraphics; ARect: TRectF; AFillColor: TTMSFNCGraphicsColor);
var
  pth: TTMSFNCGraphicsPath;
  s: Single;
begin
  AGraphics.Fill.Kind := gfkSolid;
  AGraphics.Fill.Color := AFillColor;

  AGraphics.Stroke.Kind := gskSolid;
  AGraphics.Stroke.Color := AFillColor;

  s := Floor(Min(ARect.Right - ARect.Left,  ARect.Bottom - ARect.Top)/3);

  if ARect.Right > 0 then
  begin
    pth := TTMSFNCGraphicsPath.Create;
    pth.MoveTo(PointF(ARect.Left + ((ARect.Right - ARect.Left) - s) / 2, ARect.Top + ((ARect.Bottom - ARect.Top) - s) / 2 + 1));
    pth.LineTo(PointF(ARect.Left + ((ARect.Right - ARect.Left) - s) / 2 + s / 2, ARect.Top + ((ARect.Bottom - ARect.Top) - s) / 2 + s));
    pth.LineTo(PointF(ARect.Left + ((ARect.Right - ARect.Left) - s) / 2 + s, ARect.Top + ((ARect.Bottom - ARect.Top) - s) / 2 + 1));

    pth.ClosePath;
    AGraphics.DrawPath(pth);
    pth.Free;
  end;
end;

procedure TTMSFNCCustomFilterDialog.DrawConnectionLine(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
var
  sp, ep: TPointF;
  ind, ith: single;
begin
  AGraphics.Stroke.Assign(FAppearance.ConnectionLine);

  if Assigned(FAppearance) then
    ind := FAppearance.Indent
  else
    ind := 20;

  sp := PointF((ADrawItem.Level * ind) - ind/2, ADrawItem.Rect.Top + (ADrawItem.Rect.Bottom - ADrawItem.Rect.Top)/2);

  if ADrawItem.Level > 0 then
  begin
    ep := PointF(sp.X + ind/2, sp.Y);

    AGraphics.DrawLine(sp,ep);
  end;

  if ADrawItem.EndIndex <> ADrawItem.Index then
  begin
    sp := PointF((ADrawItem.Level * ind) + ind/2, ADrawItem.Rect.Top + (ADrawItem.Rect.Bottom - ADrawItem.Rect.Top)/2);
    if FDrawItems.Count > ADrawItem.EndIndex then
      ep := PointF(sp.X, FDrawItems[ADrawItem.EndIndex].Rect.Top + (FDrawItems[ADrawItem.EndIndex].Rect.Bottom - FDrawItems[ADrawItem.EndIndex].Rect.Top)/2)
    else
    begin
      if Assigned(FAppearance) then
        ith := FAppearance.ItemHeight
      else
        ith := 30;

      ep := PointF(sp.X, sp.Y + (ith * (ADrawItem.EndIndex - ADrawItem.Index)));
    end;

    AGraphics.DrawLine(sp,ep);
  end;
end;

procedure TTMSFNCCustomFilterDialog.DrawItems(AGraphics: TTMSFNCGraphics;  ARect: TRectF);
var
  I: Integer;
begin
  for I := 0 to FDrawItems.Count - 1 do
  begin
    if Assigned(FDrawItems[I].Expression) then
      DrawExpression(AGraphics, FDrawItems[I])
    else
      DrawGroup(AGraphics, FDrawItems[I]);
  end;
end;

procedure TTMSFNCCustomFilterDialog.DrawNot(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
var
  bmpNot: TTMSFNCBitmap;
  {$IFNDEF WEBLIB}
  bsNot: TBytesStream;
  {$ENDIF}
begin
  if (ADrawItem.NotRect.Left >= 0) or (ADrawItem.NotRect.Right >= 0) then
  begin
    {$IFDEF WEBLIB}
    bmpNot := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCNOTBITMAP, HInstance));
    {$ENDIF}
    {$IFNDEF WEBLIB}
    bsNot := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCNOTBITMAP));
    try
      bmpNot := TTMSFNCBitmap.CreateFromStream(bsNot);
    finally
      bsNot.Free;
    end;
    {$ENDIF};

    {$IFNDEF WEBLIB}
    if ADrawItem.IsInverted and bmpNot.HasSVG then
      bmpNot.SVG.CustomFillColor := FAppearance.ThemeColor;
    {$ENDIF}

    try
      AGraphics.DrawBitmap(ADrawItem.NotRect, bmpNot);
    finally
      bmpNot.Free;
    end;
  end;
end;

//procedure TTMSFNCCustomFilterDialog.DrawCaseSensitive(AGraphics: TTMSFNCGraphics; ADrawItem: TTMSFNCFilterDialogDrawItem);
//var
//  bmpCase: TTMSFNCBitmap;
//  {$IFNDEF WEBLIB}
//  bsCase: TBytesStream;
//  {$ENDIF}
//begin
//  if (ADrawItem.CaseRect.Left >= 0) or (ADrawItem.CaseRect.Right >= 0) then
//  begin
//    {$IFDEF WEBLIB}
//    bmpCase := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TTMSFNCCASEBITMAP, HInstance));
//    {$ENDIF}
//    {$IFNDEF WEBLIB}
//    bsCase := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCASEBITMAP));
//    try
//      bmpCase := TTMSFNCBitmap.CreateFromStream(bsCase);
//    finally
//      bsCase.Free;
//    end;
//    {$ENDIF};
//
//    if ADrawItem.CaseSensitive {$IFNDEF WEBLIB}and bmpCase.HasSVG{$ENDIF} then
//      bmpCase.SVG.CustomFillColor := FAppearance.ThemeColor;
//
//    try
//      AGraphics.DrawBitmap(ADrawItem.CaseRect, bmpCase);
//    finally
//      bmpCase.Free;
//    end;
//  end;
//end;

{$IFDEF WEBLIB}
procedure TTMSFNCCustomFilterDialog.Execute(AProc: TModalResultProc = nil; AModal: Boolean = True);
{$ELSE}
function TTMSFNCCustomFilterDialog.Execute(AModal: Boolean = True): TModalResult;
{$ENDIF}
begin
  FDialogOpen := True;
  FIsModal := AModal;

  FCopyFilterText := FilterBuilder.FilterText;

  DoBeforeExecute;

  if not Assigned(FFilterBuilder) then
  begin
    {$IFDEF WEBLIB}
    AProc(mrAbort);
    {$ELSE}
    Result := mrAbort;
    {$ENDIF}
    Exit;
  end;

  {$IFDEF WEBLIB}
  inherited;
  {$ELSE}
  Result := inherited;
  {$ENDIF}

end;

procedure TTMSFNCCustomFilterDialog.FilterItemsChanged;
begin
  UpdateExpressionEdit;
  UpdateDrawItems;
end;

function TTMSFNCCustomFilterDialog.GetDrawItemAtXY(AX, AY: Single): TTMSFNCFilterDialogDrawItem;
var
  p: TTMSFNCFilterDialogDrawItemPart;
begin
  Result := GetDrawItemAtXY(AX, AY, p);
end;

function TTMSFNCCustomFilterDialog.GetDisplayFilterText: string;
begin
  if Assigned(FFilterBuilder) then
    Result := FFilterBuilder.DisplayFilterText;
end;

function TTMSFNCCustomFilterDialog.GetDrawItemAtXY(AX, AY: Single; var APart: TTMSFNCFilterDialogDrawItemPart): TTMSFNCFilterDialogDrawItem;
var
  I: Integer;
begin
  Result := nil;
  APart := ddipNone;

  for I := 0 to FDrawItems.Count - 1 do
  begin
    if (AY >= FDrawItems[I].Rect.Top) and (AY <= FDrawItems[I].Rect.Bottom) then
    begin
      Result := FDrawItems[I];
      if (AX >= FDrawItems[I].NotRect.Left) and (AX <= FDrawItems[I].NotRect.Right) then
        APart := ddipNot
//      else if (AX >= FDrawItems[I].CaseRect.Left) and (AX <= FDrawItems[I].CaseRect.Right) then
//        APart := ddipCase
      else if (AX >= FDrawItems[I].ColumnNameRect.Left) and (AX <= FDrawItems[I].ColumnNameRect.Right) then
        APart := ddipName
      else if (AX >= FDrawItems[I].OperatorRect.Left) and (AX <= FDrawItems[I].OperatorRect.Right) then
        APart := ddipOperator
      else if (AX >= FDrawItems[I].ValueRect.Left) and (AX <= FDrawItems[I].ValueRect.Right) then
        APart := ddipValue
      else if (AX >= FDrawItems[I].ExtraValueRect.Left) and (AX <= FDrawItems[I].ExtraValueRect.Right) then
        APart := ddipExtraValue
      else if (AX >= FDrawItems[I].AddRect.Left) and (AX <= FDrawItems[I].AddRect.Right) then
        APart := ddipAdd
      else if (AX >= FDrawItems[I].DeleteRect.Left) and (AX <= FDrawItems[I].DeleteRect.Right) then
        APart := ddipDelete;
      Exit;
    end;
  end;
end;

function TTMSFNCCustomFilterDialog.GetFilterText: string;
begin
  if Assigned(FFilterBuilder) then
    FFilterText := FFilterBuilder.FilterText;
  Result := FFilterText;
end;

function TTMSFNCCustomFilterDialog.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCCustomFilterDialog.GetTextForExpressionOperator(AExpressionOperator: TTMSFNCFilterBuilderExpressionOperator): string;
begin
  case AExpressionOperator of
    feoStartsWith: Result := FOptions.UILanguage.StartsWithOperatorText;
    feoEndsWith: Result := FOptions.UILanguage.EndsWithOperatorText;
    feoContains: Result := FOptions.UILanguage.ContainsOperatorText;
    feoEqual: Result := FOptions.UILanguage.EqualOperatorText;
    feoNotEqual: Result := FOptions.UILanguage.NotEqualOperatorText;
    feoEmpty: Result := FOptions.UILanguage.EmptyOperatorText;
    feoNotEmpty: Result := FOptions.UILanguage.NotEmptyOperatorText;
    feoLargerThan: Result := FOptions.UILanguage.LargerThanOperatorText;
    feoSmallerThan: Result := FOptions.UILanguage.SmallerThanOperatorText;
    feoLargerThanOrEqual: Result := FOptions.UILanguage.LargerThanOrEqualOperatorText;
    feoSmallerThanOrEqual: Result := FOptions.UILanguage.SmallerThanOrEqualOperatorText;
    else
      Result := 'UNKNOWN OPERATOR';
  end;
end;

function TTMSFNCCustomFilterDialog.ExpressionOperatorFoundForText(AText: string; var AExpressionOperator: TTMSFNCFilterBuilderExpressionOperator): Boolean;
begin
  Result := True;

  if Trim(AText) = FOptions.UILanguage.StartsWithOperatorText then
    AExpressionOperator := feoStartsWith
  else if Trim(AText) = Trim(FOptions.UILanguage.EndsWithOperatorText) then
    AExpressionOperator := feoEndsWith
  else if Trim(AText) = Trim(FOptions.UILanguage.ContainsOperatorText) then
    AExpressionOperator := feoContains
  else if Trim(AText) = Trim(FOptions.UILanguage.EqualOperatorText) then
    AExpressionOperator := feoEqual
  else if Trim(AText) = Trim(FOptions.UILanguage.NotEqualOperatorText) then
    AExpressionOperator := feoNotEqual
  else if Trim(AText) = Trim(FOptions.UILanguage.EmptyOperatorText) then
    AExpressionOperator := feoEmpty
  else if Trim(AText) = Trim(FOptions.UILanguage.NotEmptyOperatorText) then
    AExpressionOperator := feoNotEmpty
  else if Trim(AText) = Trim(FOptions.UILanguage.LargerThanOperatorText) then
    AExpressionOperator := feoLargerThan
  else if Trim(AText) = Trim(FOptions.UILanguage.SmallerThanOperatorText) then
    AExpressionOperator := feoSmallerThan
  else if Trim(AText) = Trim(FOptions.UILanguage.LargerThanOrEqualOperatorText) then
    AExpressionOperator := feoLargerThanOrEqual
  else if Trim(AText) = Trim(FOptions.UILanguage.SmallerThanOrEqualOperatorText) then
    AExpressionOperator := feoSmallerThanOrEqual
  else
    Result := False;
end;

function TTMSFNCCustomFilterDialog.GetTextForGroupOperator(AGroupOperator: TTMSFNCFilterBuilderGroupOperator): string;
begin
  case AGroupOperator of
    fgoAND: Result := FOptions.UILanguage.AndOperatorText;
    fgoOR: Result := FOptions.UILanguage.OrOperatorText;
    else
      Result := 'UNKNOWN OPERATOR';
  end;
end;

function TTMSFNCCustomFilterDialog.GroupOperatorFoundForText(AText: string; var AGroupOperator: TTMSFNCFilterBuilderGroupOperator): Boolean;
begin
  Result := True;

  if Trim(AText) = Trim(FOptions.UILanguage.AndOperatorText) then
    AGroupOperator := fgoAND
  else if Trim(AText) = Trim(FOptions.UILanguage.OrOperatorText) then
    AGroupOperator := fgoOR
  else
    Result := False;
end;

procedure TTMSFNCCustomFilterDialog.HandleEditorResult(AChange: Boolean);
var
  txt: string;
  fs: TFormatSettings;
  v: TTMSFNCValue;
  go: TTMSFNCFilterBuilderGroupOperator;
  eo: TTMSFNCFilterBuilderExpressionOperator;
  dt: TTMSFNCFilterBuilderDataType;
begin
  txt := '';
  if Assigned(FChangeCombo) then
  begin
    txt := FChangeCombo.Text;
    FChangeCombo.CloseDropDown;
  end;

  if AChange and (FEditorValueText <> txt) and (FEditorIndex >= 0) and (FEditorIndex < FDrawItems.Count) then
  begin
      if Assigned(FDrawItems[FEditorIndex].Group) then
      begin
        if (FEditorPart = ddipOperator) and GroupOperatorFoundForText(txt, go) then
          FDrawItems[FEditorIndex].Group.GroupOperator := go
        else if (FEditorPart = ddipAdd) then
        begin
          if Trim(txt) = (FOptions.FUILanguage.AddExpression) then
            FDrawItems[FEditorIndex].Group.Expressions.Add
          else if Trim(txt) = (FOptions.FUILanguage.AddGroup) then
            FDrawItems[FEditorIndex].Group.Groups.Add;
        end;
      end
      else if Assigned(FDrawItems[FEditorIndex].Expression) then
      begin
        case FEditorPart of
          ddipName:
          begin
            if Assigned(FDrawItems[FEditorIndex].Expression.Column) then
              dt := FDrawItems[FEditorIndex].Expression.Column.DataType
            else
              dt := fdtAutomatic;

            FDrawItems[FEditorIndex].Expression.SetColumnByName(txt);

            if (FDrawItems[FEditorIndex].Expression.GetValueDataType <> fdtAutomatic) and (dt <> FDrawItems[FEditorIndex].Expression.GetValueDataType)
             and not ((dt = fdtNumber) and (FDrawItems[FEditorIndex].Expression.GetValueDataType = fdtFloat)) then
            begin
              if (FDrawItems[FEditorIndex].Expression.GetValueDataType = fdtBoolean) then
                FDrawItems[FEditorIndex].Expression.ExpressionOperator := feoEqual
              else
                FDrawItems[FEditorIndex].Expression.ExpressionOperator := feoNotEmpty;
              FDrawItems[FEditorIndex].Expression.Value := TValueToFNCValue(TValue.Empty);
            end;
          end;
          ddipOperator:
          begin
            if ExpressionOperatorFoundForText(txt, eo) then
              FDrawItems[FEditorIndex].Expression.ExpressionOperator := eo;
          end;
          ddipValue:
          begin
            fs := FFilterBuilder.GetFormatSettings;
            DoGetFormatSettings(fs);
            if Assigned(FDrawItems[FEditorIndex].Expression.Column) then
              dt := FDrawItems[FEditorIndex].Expression.Column.DataType
            else
              dt := fdtAutomatic;

            if dt = fdtBoolean then
            begin
              if txt = FOptions.UILanguage.TrueText then
                v := True
              else
                v := False;
            end
            else if dt = fdtDate then
              v := EncodeDate(YearOf(FChangeCombo.DateTime), MonthOf(FChangeCombo.DateTime), DayOf(FChangeCombo.DateTime))
            else if dt = fdtTime then
              v := EncodeTime(HourOf(FChangeCombo.DateTime), MinuteOf(FChangeCombo.DateTime), SecondOf(FChangeCombo.DateTime), 0)
            else if dt = fdtDateTime then
              v := EncodeDateTime(YearOf(FChangeCombo.DateTime), MonthOf(FChangeCombo.DateTime), DayOf(FChangeCombo.DateTime), HourOf(FEditorDate), MinuteOf(FEditorDate), SecondOf(FEditorDate), 0)
            else
              v := ParseValueTextToFNCValue(txt, dt, fs);

            FDrawItems[FEditorIndex].Expression.Value := v;
          end;
          ddipExtraValue:
          begin
            fs := FFilterBuilder.GetFormatSettings;
            DoGetFormatSettings(fs);
            if Assigned(FDrawItems[FEditorIndex].Expression.Column) then
              dt := FDrawItems[FEditorIndex].Expression.Column.DataType
            else
              dt := fdtAutomatic;

            if dt = fdtDateTime then
            begin
              v := EncodeDateTime(YearOf(FEditorDate), MonthOf(FEditorDate), DayOf(FEditorDate), HourOf(FChangeCombo.DateTime), MinuteOf(FChangeCombo.DateTime), SecondOf(FChangeCombo.DateTime), 0);
              FDrawItems[FEditorIndex].Expression.Value := v;
            end;
          end;
        end;
      end;

      UpdateDrawItems;
  end;

  ResetChangeControls;
end;

procedure TTMSFNCCustomFilterDialog.ItemClick(ADrawItem: TTMSFNCFilterDialogDrawItem; APart: TTMSFNCFilterDialogDrawItemPart);
var
  editorType: TTMSFNCFilterDialogEditorType;
  er: TRectF;
  sl: TStringList;
  fixed, sh: Boolean;
  ep: TTMSFNCFilterDialogEditorProperties;
  op: TTMSFNCFilterDialogOpenControlParameters;

  procedure AddAllGroupOperators;
  var
    go: TTMSFNCFilterBuilderGroupOperator;
  begin
    sl.Clear;
    for go := Low(TTMSFNCFilterBuilderGroupOperator) to High(TTMSFNCFilterBuilderGroupOperator) do
    begin
      sl.Add(GetTextForGroupOperator(go));
    end;
  end;
  procedure AddColumnNames;
  var
    I: Integer;
  begin
    for I := 0 to FFilterBuilder.DataColumns.Count - 1 do
    begin
      sl.Add(FFilterBuilder.DataColumns[I].DisplayName);
    end;
  end;
  procedure AddAllExpressionsOperator;
  var
    eo: TTMSFNCFilterBuilderExpressionOperator;
  begin
    for eo := Low(TTMSFNCFilterBuilderExpressionOperator) to High(TTMSFNCFilterBuilderExpressionOperator) do
    begin
      sl.Add(GetTextForExpressionOperator(eo));
    end;
  end;
  procedure AddNumericExpressionsOperator;
  var
    eo: TTMSFNCFilterBuilderExpressionOperator;
  begin
    for eo := Low(TTMSFNCFilterBuilderExpressionOperator) to High(TTMSFNCFilterBuilderExpressionOperator) do
    begin
      if eo in DefaultNumberOperators then
        sl.Add(GetTextForExpressionOperator(eo));
    end;
  end;
  procedure AddTextExpressionsOperator;
  var
    eo: TTMSFNCFilterBuilderExpressionOperator;
  begin
    for eo := Low(TTMSFNCFilterBuilderExpressionOperator) to High(TTMSFNCFilterBuilderExpressionOperator) do
    begin
      if eo in DefaultTextOperators then
        sl.Add(GetTextForExpressionOperator(eo));
    end;
  end;
  procedure AddOtherExpressionsOperator;
  begin
    sl.Add(GetTextForExpressionOperator(feoEmpty));
    sl.Add(GetTextForExpressionOperator(feoNotEmpty));
  end;
begin
  if APart in [ddipDelete] then
  begin
    begin
      if Assigned(ADrawItem.Group) then
        FFilterBuilder.DeleteGroup(ADrawItem.Group)
      else if Assigned(ADrawItem.Expression) then
        FFilterBuilder.DeleteExpression(ADrawItem.Expression);
    end;
    UpdateDrawItems;

    Exit;
  end
//  else if APart = ddipCase then
//  begin
//    ADrawItem.Expression.CaseSensitive := not ADrawItem.Expression.CaseSensitive;
//
//    UpdateExpressionEdit;
//    UpdateDrawItems;
//
//    Exit;
//  end
  else if APart = ddipNot then
  begin
    ADrawItem.Expression.IsInverted := not ADrawItem.Expression.IsInverted;

    UpdateExpressionEdit;
    UpdateDrawItems;

    Exit;
  end;

  sh := True;

  FEditorIndex := ADrawItem.Index;
  FEditorPart := APart;

  editorType := vetEdit;

  sl := TStringList.Create;
  op.HideEdit := False;

  case APart of
    ddipNone: er := ADrawItem.Rect;
    ddipAdd:
    begin
      op.HideEdit := True;
      er := ADrawItem.AddRect;
      editorType := vetComboBox;
      sl.Add(FOptions.UILanguage.AddExpression);
      sl.Add(FOptions.UILanguage.AddGroup);
    end;
    ddipName:
    begin
      ep.EditorText := ADrawItem.ColumnNameText;
      er := ADrawItem.ColumnNameRect;
      AddColumnNames;
      if FFilterBuilder.DataColumns.Count > 0 then
        editorType := vetComboBox;
    end;
    ddipOperator:
    begin
      ep.EditorText := ADrawItem.OperatorText;
      er := ADrawItem.OperatorRect;
      editorType := vetComboBox;

      if Assigned(ADrawItem.Group) then
        AddAllGroupOperators
      else if Assigned(ADrawItem.Expression) then
      begin
        case ADrawItem.ValueType of
          fdtAutomatic: AddAllExpressionsOperator;
          fdtText: AddTextExpressionsOperator;
          fdtBoolean:
          begin
            ep.EditorText := GetTextForExpressionOperator(feoEqual);

            sh := False;
          end;
          fdtOther: AddOtherExpressionsOperator;
          fdtDateTime, fdtDate, fdtTime: AddNumericExpressionsOperator;
          fdtFloat, fdtNumber: AddNumericExpressionsOperator;
        end;
      end;
    end;
    ddipValue:
    begin
      ep.EditorText := ADrawItem.ValueText;
      er := ADrawItem.ValueRect;
      if ADrawItem.ValueType = fdtBoolean then
      begin
        sl.Add(FOptions.FUILanguage.TrueText);
        sl.Add(FOptions.FUILanguage.FalseText);
        editorType := vetComboBox;
      end
      else if ADrawItem.ValueType in [fdtDateTime, fdtDate] then
      begin
        editorType := vetDatePicker;
        ep.EditorDate := ValueToDateTime(ADrawItem.Value);
        ep.EditorText := '';
      end
      else if ADrawItem.ValueType in [fdtTime] then
      begin
        editorType := vetTimePicker;
        ep.EditorDate := ValueToDateTime(ADrawItem.Value);
        ep.EditorText := '';
      end
      else if not (ADrawItem.ValueType in [fdtFloat, fdtNumber]) and Assigned(ADrawItem.Expression.Column) {and (ADrawItem.Expression.ExpressionOperator in [feoEqual, feoNotEqual])} then
      begin
        DoGetExpressionValueList(ADrawItem.Expression.Column, sl);
        if sl.Count > 0  then
          editorType := vetComboEdit;
      end;
    end;
    ddipExtraValue:
    begin
      ep.EditorDate := ValueToDateTime(ADrawItem.Value);
      er := ADrawItem.ExtraValueRect;
      editorType := vetTimePicker;
    end;
  end;

  fixed := not (editorType in [vetEdit, vetComboEdit]);

  ep.EditorPart := APart;
  ep.EditorType := editorType;
  InflateRectEx(er, -2, 0);
  {$IFNDEF FMXLIB}
  InflateRectEx(er, -2, -2);
  {$ENDIF}
  ep.EditorRect := er;

  if Assigned(ADrawItem.Group) then
    DoShowGroupEditorEvent(ADrawItem.Group, ep, sl, fixed, sh)
  else if Assigned(ADrawItem.Expression) then
    DoShowExpressionEditorEvent(ADrawItem.Expression, ep, sl, fixed, sh);

  op.DrawItem := ADrawItem;
  op.PartRect := ep.EditorRect;
  op.Part := APart;
  op.List := sl;
  op.Fixed := fixed;
  op.Editor := ep.EditorType;

  if op.Editor in [vetDatePicker, vetTimePicker] then
  begin
    op.DateTime := ValueToDateTime(ADrawItem.Value);
    op.Text := '';
  end
  else
  begin
    op.Text := ep.EditorText;
    op.DateTime := -1;
  end;

  if sh then
  begin
    FEditorValueText := ep.EditorText;
    FEditorDate := op.DateTime;
    if ep.EditorType = vetCustom then
      DoShowCustomEditor(ADrawItem, ep)
    else
      OpenCombo(op);
  end;

  sl.Free;
end;

procedure TTMSFNCCustomFilterDialog.OpenCombo(AOpenParameters: TTMSFNCFilterDialogOpenControlParameters);
begin
  FChangeCombo.BeginUpdate;

  FChangeCombo.Appearance.ControlFill.Assign(FTopPanel.Appearance.Fill);
  FChangeCombo.Appearance.ControlStroke.Assign(FTopPanel.Appearance.Stroke);
  FChangeCombo.Appearance.ControlFont.Color := GetEditorDefaultFontColor;

  case AOpenParameters.Part of
    ddipName:
    begin
      FChangeCombo.Appearance.EditFill.Assign(FAppearance.ExpressionColumnFill);
      FChangeCombo.Appearance.EditFont.Assign(FAppearance.ExpressionColumnFont);
      FChangeCombo.Appearance.EditStroke.Color := FAppearance.ExpressionColumnFill.Color;
    end;
    ddipValue:
    begin
    begin
      FChangeCombo.Appearance.EditFill.Assign(FAppearance.ExpressionValueFill);
      FChangeCombo.Appearance.EditFont.Assign(FAppearance.ExpressionValueFont);
      FChangeCombo.Appearance.EditStroke.Color := FAppearance.ExpressionValueFill.Color;
    end;
    end;
    ddipAdd: ;
    ddipOperator:
    begin
      if Assigned(AOpenParameters.DrawItem.Group) then
      begin
        FChangeCombo.Appearance.EditFill.Assign(FAppearance.GroupFill);
        FChangeCombo.Appearance.EditFont.Assign(FAppearance.GroupFont);
        FChangeCombo.Appearance.EditStroke.Color := FAppearance.GroupFill.Color;
      end
      else if Assigned(AOpenParameters.DrawItem.Expression) then
      begin
        FChangeCombo.Appearance.EditFill.Assign(FAppearance.ExpressionOperatorFill);
        FChangeCombo.Appearance.EditFont.Assign(FAppearance.ExpressionOperatorFont);
        FChangeCombo.Appearance.EditStroke.Color := FAppearance.ExpressionOperatorFill.Color;
      end
    end;
  end;
  FChangeCombo.Appearance.ControlFill.Assign(FTopPanel.Appearance.Fill);
  FChangeCombo.Appearance.ControlStroke.Assign(FTopPanel.Appearance.Stroke);
  FChangeCombo.Appearance.ControlFont.Color := GetEditorDefaultFontColor;

  FChangeCombo.HideEdit := AOpenParameters.HideEdit;

  FChangeCombo.EndUpdate;

  FChangeCombo.Items.AddStrings(AOpenParameters.List, True);

  FChangeCombo.DropDownHeight := FDefaultDropDownHeight;

  FChangeCombo.EditType := etString;
  if AOpenParameters.Part = ddipValue then
  begin
    case AOpenParameters.DrawItem.ValueType of
      fdtFloat: FChangeCombo.EditType := etFloat;
      fdtNumber: FChangeCombo.EditType := etNumeric;
    end;
  end;

  FChangeCombo.DisableEditKeyInput := AOpenParameters.Fixed;

  case AOpenParameters.Editor of
    vetEdit: FChangeCombo.DropDownType := ddetEdit;
    vetComboBox, vetComboEdit:
    begin
      FChangeCombo.Appearance.ListBoxItemHoverFill.Assign(FAppearance.DropDownHoverFill);
      FChangeCombo.Appearance.ListBoxItemHoverFont.Assign(FAppearance.DropDownHoverFont);

      if AOpenParameters.Fixed then
        FChangeCombo.DropDownType := ddetComboBox
      else
        FChangeCombo.DropDownType := ddetComboEdit;
      FChangeCombo.DropDownWidth := 140;
      FChangeCombo.DropDownHeight := Min(FDefaultDropDownHeight,  FChangeCombo.GetListBoxItemHeight * AOpenParameters.List.Count + 4);
    end;
    vetTimePicker:
    begin
      FChangeCombo.DropDownType := ddetTimePicker;
      FChangeCombo.DropDownHeight := 180;
      FChangeCombo.DropDownWidth := 180;
    end;
    vetDatePicker:
    begin
      FChangeCombo.DropDownType := ddetDatePicker;
      FChangeCombo.DropDownHeight := 180;
      FChangeCombo.DropDownWidth := 180;
    end;
  end;

  {$IFDEF FMXLIB}
  FChangeCombo.NeedStyleLookup;
  FChangeCombo.Position.X := AOpenParameters.PartRect.Left;
  FChangeCombo.Position.Y := AOpenParameters.PartRect.Top;
  FChangeCombo.Width := AOpenParameters.PartRect.Right - AOpenParameters.PartRect.Left;
  FChangeCombo.Height := AOpenParameters.PartRect.Bottom - AOpenParameters.PartRect.Top;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChangeCombo.Left := Floor(AOpenParameters.PartRect.Left);
  FChangeCombo.Top := Floor(AOpenParameters.PartRect.Top);
  FChangeCombo.Width := Floor(AOpenParameters.PartRect.Right - AOpenParameters.PartRect.Left);
  FChangeCombo.Height := Floor(AOpenParameters.PartRect.Bottom - AOpenParameters.PartRect.Top);
  {$ENDIF}

  FChangeCombo.HideEdit := not (AOpenParameters.Editor in [vetEdit, vetComboEdit]);

  FChangeCombo.DateTime := AOpenParameters.DateTime;
  if AOpenParameters.DateTime < 0 then
    FChangeCombo.Text := AOpenParameters.Text;

  FEditorValueText := AOpenParameters.Text;

  FChangeCombo.Visible := True;
  FChangeCombo.OpenDropDown;
  FEditorOpen := True;
end;

procedure TTMSFNCCustomFilterDialog.ResetChangeControls;
begin
  if Assigned(FChangeCombo) then
  begin
    FChangeCombo.Visible := False;
    FChangeCombo.Items.Clear;
  end;
  FEditorValueText := '';
  FEditorIndex := -1;
  FEditorPart := ddipNone;
  FEditorOpen := False;

  if Assigned(FPreview) then
    FPreview.Invalidate;
end;

procedure TTMSFNCCustomFilterDialog.ResetHoveredItem;
begin
  FHoveredItemIndex := -1;
  FHoverItemPart := ddipNone;
end;

procedure TTMSFNCCustomFilterDialog.UpdateDrawItems;
var
  leftTxtSp, RightTxtSp, TopTxtSp, BottomTxtSp: Integer;
  ind, ith, ComboLength, ArrSpace, AddSpace, rnd, wdt, offx: Single;
  idx: Integer;
  icm: TTMSFNCMargins;
  fs: TFormatSettings;

  procedure AddExpression(AExpression: TTMSFNCFilterBuilderExpression; ALevel: Integer);
  var
    g: TTMSFNCGraphics;
    twName, twOp, twVal, twExVal: Single;
    it: TTMSFNCFilterDialogDrawItem;
    s: single;
  begin
    idx := FDrawItems.Count;
    it := FDrawItems.AddItem(AExpression, ALevel);
    it.Rect := RectF(0, idx * ith ,wdt, (idx + 1) * ith);
    it.Rounding := rnd;

    it.ColumnNameText := AExpression.GetColumnDisplayName;
    it.OperatorText := GetTextForExpressionOperator(AExpression.ExpressionOperator);

    it.FValueType := AExpression.GetValueDataType;
    case it.FValueType of
      fdtDateTime:
      begin
        if ValueIsEmpty(AExpression.Value) then
          AExpression.Value := Now;

        it.ValueText := DateToStr(ValueToDateTime(AExpression.Value, fs), fs);
        it.ExtraValueText := TimeToStr(ValueToDateTime(AExpression.Value, fs), fs);
      end;
      fdtDate:
      begin
        if ValueIsEmpty(AExpression.Value) then
          AExpression.Value := Now;

        if ValueIsDateTime(AExpression.Value, fs) then
          it.ValueText := DateToStr(ValueToDateTime(AExpression.Value, fs), fs)
        else
          it.ValueText := FNCValueToString(AExpression.Value, fs);
      end;
      fdtTime:
      begin
        if ValueIsEmpty(AExpression.Value) then
          AExpression.Value := 0;

        if ValueIsDateTime(AExpression.Value, fs) then
          it.ValueText := TimeToStr(ValueToDateTime(AExpression.Value, fs), fs)
        else
          it.ValueText := FNCValueToString(AExpression.Value, fs);
      end;
      fdtText:
      begin
        it.ValueText := ValueToString(AExpression.Value);
      end;
      fdtBoolean:
      begin
        if ValueToBoolean(AExpression.Value, fs) then
          it.ValueText := FOptions.UILanguage.TrueText
        else
          it.ValueText := FOptions.UILanguage.FalseText;
      end
      else
        it.ValueText := FNCValueToString(AExpression.Value, fs);
    end;

    it.Value := AExpression.Value;

    s := Min(AddSpace - 20, (it.Rect.Bottom - it.Rect.Top - 2))/2;
    it.FDeleteRect := RectF(it.Rect.Right - s -10, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2, it.Rect.Right - 10, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2 + s);
    it.FAddRect := RectF(-1,-1,-1,-1);
    it.FNotRect := RectF(it.Rect.Left + ((ALevel + 1) * ind) + icm.Left, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2, it.Rect.Left + ((ALevel + 1) * ind) + icm.Left + s, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2 + s);

//    if (FilterBuilder.FormatType <> fftDelphiDataSet) and ((it.ValueType = fdtText) or ((it.ValueType = fdtAutomatic) and ContainsLetters(it.ValueText))) then
//      it.FCaseRect := RectF(it.FNotRect.Right + icm.Right + icm.Left, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2, it.FNotRect.Right + icm.Right + icm.Left + s, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2 + s)
//    else
//      it.FCaseRect := RectF(-1,-1,-1,-1);

    twExVal := 0;

    it.IsInverted := AExpression.IsInverted;
//    it.CaseSensitive := AExpression.CaseSensitive;

    g := TTMSFNCGraphics.Create(FPreview.Canvas);
    try
      if Assigned(FAppearance) then
        g.Font.Assign(FAppearance.ExpressionColumnFont);
      twName := Max(g.CalculateTextWidth(it.ColumnNameText) + leftTxtSp + RightTxtSp, ComboLength);
      if Assigned(FAppearance) then
        g.Font.Assign(FAppearance.ExpressionOperatorFont);
      twOp := Max(g.CalculateTextWidth(it.OperatorText) + leftTxtSp + RightTxtSp, ComboLength);
      if Assigned(FAppearance) then
        g.Font.Assign(FAppearance.ExpressionValueFont);
      if it.ExtraValueText <> '' then
        twExVal:= Max(g.CalculateTextWidth(it.ExtraValueText) + leftTxtSp + RightTxtSp, ComboLength);

      twVal := Max(twExVal + g.CalculateTextWidth(it.ValueText) + leftTxtSp + RightTxtSp, ComboLength);
    finally
      g.Free;
    end;

    offx := (ALevel + 1) * ind + (3 * icm.Left) + (2*icm.Right) + (3 * ArrSpace) + AddSpace/2 + (it.NotRect.Right - it.NotRect.Left);

    if offx + twName + twOp + twVal > wdt then
    begin
      if (wdt - (offx + twName + twOp) >= ComboLength) then
        twVal := wdt - (offx + twName + twOp)
      else
      begin
        twVal := ComboLength;

        if (wdt - (offx + twVal + twOp) >= ComboLength) then
          twName := wdt - (offx + twVal + twOp)
        else
        begin
          twName := ComboLength;

          if (wdt - (offx + twName + twVal) >= ComboLength) then
            twOp := wdt - (offx + twVal + twName)
          else
            twOp := ComboLength;
        end;
      end;
    end;

    it.FColumnNameRect := it.Rect;
    it.FColumnNameRect.Top := it.Rect.Top + icm.Top;
    it.FColumnNameRect.Bottom := it.Rect.Bottom - icm.Bottom;
//    if it.CaseRect.Right > 0 then
//      it.FColumnNameRect.Left := it.CaseRect.Right + icm.Right + icm.Left
//    else
      it.FColumnNameRect.Left := it.NotRect.Right + icm.Right + icm.Left;
    it.FColumnNameRect.Right := it.ColumnNameRect.Left + twName + ArrSpace;

    if FFilterBuilder.DataColumns.Count > 0 then
    begin
      it.FColumnNameArrowRect.Right := it.ColumnNameRect.Right  - 4;
      it.FColumnNameArrowRect.Left := it.ColumnNameRect.Right - ArrSpace + 4;
      it.FColumnNameArrowRect.Top := it.ColumnNameRect.Top + 4;
      it.FColumnNameArrowRect.Bottom := it.ColumnNameRect.Bottom - 4;
    end;

    it.FColumnNameTextRect.Right := it.ColumnNameRect.Right - ArrSpace - RightTxtSp;
    it.FColumnNameTextRect.Top := it.ColumnNameRect.Top + TopTxtSp;
    it.FColumnNameTextRect.Bottom := it.ColumnNameRect.Bottom - RightTxtSp;
    it.FColumnNameTextRect.Left := it.ColumnNameRect.Left + leftTxtSp;

    it.FOperatorRect := it.Rect;
    it.FOperatorRect.Top := it.Rect.Top + icm.Top;
    it.FOperatorRect.Bottom := it.Rect.Bottom - icm.Bottom;
    it.FOperatorRect.Left := it.ColumnNameRect.Right + icm.Right + icm.Left;
    it.FOperatorRect.Right := it.OperatorRect.Left + twOp + ArrSpace;

    if AExpression.GetValueDataType <> fdtBoolean then
    begin
      it.FOperatorArrowRect.Right := it.OperatorRect.Right  - 4;
      it.FOperatorArrowRect.Left := it.OperatorRect.Right - ArrSpace + 4;
      it.FOperatorArrowRect.Top := it.OperatorRect.Top + 4;
      it.FOperatorArrowRect.Bottom := it.OperatorRect.Bottom - 4;
    end;

    it.FOperatorTextRect.Left := it.OperatorRect.Left + leftTxtSp;
    it.FOperatorTextRect.Right := it.OperatorRect.Right - ArrSpace - RightTxtSp;
    it.FOperatorTextRect.Top := it.OperatorRect.Top + TopTxtSp;
    it.FOperatorTextRect.Bottom := it.OperatorRect.Bottom - BottomTxtSp;

    if not (AExpression.ExpressionOperator in [feoEmpty, feoNotEmpty]) then
    begin
      it.FValueRect := it.Rect;
      it.FValueRect.Top := it.Rect.Top + icm.Top;
      it.FValueRect.Bottom := it.Rect.Bottom - icm.Bottom;
      it.FValueRect.Left := it.OperatorRect.Right + icm.Right + icm.Left;
      it.FValueRect.Right := Min(it.ValueRect.Left + twVal - twExVal + ArrSpace, it.Rect.Right - twExVal - AddSpace);

      if it.ValueType in COMBOTYPES then
      begin
        it.FValueArrowRect.Right := it.ValueRect.Right  - 4;
        it.FValueArrowRect.Left := it.ValueRect.Right - ArrSpace + 4;
        it.FValueArrowRect.Top := it.ValueRect.Top + 4;
        it.FValueArrowRect.Bottom := it.ValueRect.Bottom - 4;
      end
      else
        it.FValueArrowRect := RectF(-1,-1,-1,-1);

      it.FValueTextRect.Left := it.ValueRect.Left + leftTxtSp;
      it.FValueTextRect.Right := it.ValueRect.Right - RightTxtSp;
      if it.ValueType in COMBOTYPES then
      begin
        it.FValueTextRect.Right := it.ValueTextRect.Right - ArrSpace;
      end;
      it.FValueTextRect.Top := it.ValueRect.Top + TopTxtSp;
      it.FValueTextRect.Bottom := it.ValueRect.Bottom - BottomTxtSp;


      if (it.FExtraValueText <> '') then
      begin
        it.FExtraValueRect := it.Rect;
        it.FExtraValueRect.Top := it.FValueRect.Top;
        it.FExtraValueRect.Bottom := it.FValueRect.Bottom;
        it.FExtraValueRect.Left := it.FValueRect.Right + icm.Left;
        it.FExtraValueRect.Right := Min(it.ExtraValueRect.Left + twExVal + ArrSpace, it.Rect.Right - AddSpace);

        if it.ValueType in COMBOTYPES then
        begin
          it.FExtraValueArrowRect.Right := it.ExtraValueRect.Right  - 4;
          it.FExtraValueArrowRect.Left := it.ExtraValueRect.Right - ArrSpace + 4;
          it.FExtraValueArrowRect.Top := it.ExtraValueRect.Top + 4;
          it.FExtraValueArrowRect.Bottom := it.ExtraValueRect.Bottom - 4;
        end
        else
          it.FExtraValueArrowRect := RectF(-1,-1,-1,-1);

        it.FExtraValueTextRect.Left := it.ExtraValueRect.Left + leftTxtSp;
        it.FExtraValueTextRect.Right := it.ExtraValueRect.Right - RightTxtSp;
        if it.ValueType in COMBOTYPES then
        begin
          it.FExtraValueTextRect.Right := it.ExtraValueTextRect.Right - ArrSpace;
        end;
        it.FExtraValueTextRect.Top := it.ExtraValueRect.Top + TopTxtSp;
        it.FExtraValueTextRect.Bottom := it.ExtraValueRect.Bottom - BottomTxtSp;
      end;
    end
    else
      it.FValueRect := RectF(-1,-1,-1,-1);
  end;

  procedure AddGroups(AGroup: TTMSFNCFilterBuilderGroup; ALevel: Integer);
  var
    g: TTMSFNCGraphics;
    s, twOp: Single;
    I: Integer;
    it: TTMSFNCFilterDialogDrawItem;
  begin
    idx := FDrawItems.Count;

    it := FDrawItems.AddItem(AGroup, ALevel);
    it.Level := ALevel;
    it.Rect := RectF(0, it.Index * ith ,wdt, (it.Index + 1) * ith);
    it.Rounding := rnd;

    s := Min(AddSpace - 20, (it.Rect.Bottom - it.Rect.Top - 2))/2;
    it.FDeleteRect := RectF(it.Rect.Right - s -10, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2, it.Rect.Right - 10, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2 + s);

    it.FAddRect := RectF(it.FDeleteRect.Left - 5 - s, it.FDeleteRect.Top, it.FDeleteRect.Left - 5, it.FDeleteRect.Bottom);

    it.OperatorText := GetTextForGroupOperator(AGroup.GroupOperator);
    g := TTMSFNCGraphics.Create(FPreview.Canvas);
    try
      if Assigned(FAppearance) then
        g.Font.Assign(FAppearance.GroupFont);
      twOp := Max(g.CalculateTextWidth(FDrawItems[idx].OperatorText) + leftTxtSp + RightTxtSp, ComboLength);
    finally
      g.Free;
    end;

    it.FOperatorRect := it.Rect;
    it.FOperatorRect.Top := it.Rect.Top + icm.Top;
    it.FOperatorRect.Bottom := it.Rect.Bottom - icm.Bottom;
    it.FOperatorRect.Left := it.Rect.Left + ((ALevel + 1) * ind) + icm.Left;
    it.FOperatorRect.Right := it.OperatorRect.Left + twOp + ArrSpace;

    it.FOperatorArrowRect.Right := it.OperatorRect.Right  - 4;
    it.FOperatorArrowRect.Left := it.OperatorRect.Right - ArrSpace + 4;
    it.FOperatorArrowRect.Top := it.OperatorRect.Top + 4;
    it.FOperatorArrowRect.Bottom := it.OperatorRect.Bottom - 4;

    it.FOperatorTextRect.Left := it.OperatorRect.Left + leftTxtSp;
    it.FOperatorTextRect.Right := it.OperatorRect.Right - ArrSpace - RightTxtSp;
    it.FOperatorTextRect.Top := it.OperatorRect.Top + TopTxtSp;
    it.FOperatorTextRect.Bottom := it.OperatorRect.Bottom - BottomTxtSp;

    for I := 0 to AGroup.Groups.Count - 1 do
    begin
      AddGroups(AGroup.Groups[I],ALevel + 1);
    end;

    for I := 0 to AGroup.Expressions.Count - 1 do
    begin
      AddExpression(AGroup.Expressions[I], ALevel + 1);
    end;

    if AGroup = FFilterBuilder.Filter then
      it.EndIndex := idx + 1
    else
      it.EndIndex := idx;
  end;
  procedure AddLast;
  var
    s: Single;
    it: TTMSFNCFilterDialogDrawItem;
  begin
    idx := FDrawItems.Count;
    it := FDrawItems.AddItem;
    it.Group := FFilterBuilder.Filter;
    it.Level := 1;
    it.Rect := RectF(0, it.Index * ith ,wdt, (it.Index + 1) * ith);
    it.Rounding := rnd;

    s := Min(AddSpace - 20, (it.Rect.Bottom - it.Rect.Top - 2))/2;

    it.FAddRect := RectF(it.Rect.Left + (it.Level + 1) * ind + icm.Left, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2, it.Rect.Left + ((it.Level + 1) * ind) + icm.Left + s, it.Rect.Top + (it.Rect.Bottom - it.Rect.Top - s)/2 + s);

    it.EndIndex := idx;
  end;
begin
  if not Assigned(FPreview) then
    Exit;

  FNotText := FilterBuilder.ParseFormat.NotOperator;

  ComboLength := FPreview.ScalePaintValue(50);
  ArrSpace := FPreview.ScalePaintValue(20);
  AddSpace := FPreview.ScalePaintValue(60);

  leftTxtSp := FPreview.ScalePaintValue(5);
  RightTxtSp := FPreview.ScalePaintValue(3);
  TopTxtSp := FPreview.ScalePaintValue(3);
  BottomTxtSp := FPreview.ScalePaintValue(3);

  fs := TFormatSettings.Create;
  DoGetFormatSettings(fs);

  icm := TTMSFNCMargins.Create(RectF(FPreview.ScalePaintValue(4), FPreview.ScalePaintValue(4) ,FPreview.ScalePaintValue(4), FPreview.ScalePaintValue(6)));

  if Assigned(FPreview) then
    wdt := FPreview.Width
  else
    wdt := Form.Width;

  if Assigned(FAppearance) then
  begin
    ind := FAppearance.Indent;
    ith := FAppearance.ItemHeight;
    icm.Assign(FAppearance.ItemControlsMargins);
    rnd := FAppearance.ItemRounding;
  end
  else
  begin
    ind := FPreview.ScalePaintValue(20);
    ith := FPreview.ScalePaintValue(30);
    rnd := FPreview.ScalePaintValue(4);
  end;

  FDrawItems.Clear;

  AddGroups(FFilterBuilder.Filter, 0);
  AddLast;

  icm.Free;

  FPreview.Height := Floor((FDrawItems.Count + 1) * ith) + 1;
  FPreview.Invalidate;

  UpdateExpressionEdit;
end;

procedure TTMSFNCCustomFilterDialog.UpdateExpressionEdit;
var
  cpos: Integer;
begin
  if Assigned(FExpressionEdit) then
  begin
    if FExpressionEdit.Text <> FFilterBuilder.DisplayFilterText then
    begin
      cpos := -1;
      if FExpressionEdit.IsFocused then
        cpos := FExpressionEdit.SelStart;
      FExpressionEdit.Text := FFilterBuilder.DisplayFilterText;
      {$IFDEF FMXLIB}
      FExpressionEdit.FontColor := GetEditorDefaultFontColor;
      {$ENDIF}
      {$IFNDEF FMXLIB}
      FExpressionEdit.Font.Color := GetEditorDefaultFontColor;
      {$ENDIF}
      if cpos >= 0 then
        FExpressionEdit.SelStart := cpos;
    end;
  end
end;

function TTMSFNCCustomFilterDialog.ValidateFilterArray(AInputArray: TTMSFNCFilterValidateInputArray): TTMSFNCFilterValidateOutputArray;
begin
  Result := FFilterBuilder.ValidateFilterArray(AInputArray);
end;

function TTMSFNCCustomFilterDialog.ValidateFilterRow(AInputRow: TTMSFNCFilterValidateInputRow): Boolean;
begin
  Result := FFilterBuilder.ValidateFilterRow(AInputRow);
end;

procedure TTMSFNCCustomFilterDialog.SetAppearance(const Value: TTMSFNCFilterDialogAppearance);
begin
  FAppearance.Assign(Value);
  DoOnAppearanceChanged(FAppearance);
end;

procedure TTMSFNCCustomFilterDialog.SetControlAppearance(ADarkStyle: Boolean);
begin
  if Assigned(FButtonClear) then
    SetEditorCancelButtonAppearance(FButtonClear, FAppearance.ThemeColor);
  if Assigned(FPanel) then
    SetEditorSubPanelAppearance(FPanel);
  if Assigned(FVScrlBox) then
  begin
    {$IFDEF VCLWEBLIB}
    FVScrlBox.BorderStyle := bsNone;
    if ADarkStyle then
      FVScrlBox.Color := EDITORSUBBACKCOLORDARK
    else
       FVScrlBox.Color := EDITORSUBBACKCOLORLIGHT;
    {$ENDIF}
  end;
  if Assigned(FPreview) then
  begin
    if IsLightTheme then
      FPreview.Color := EDITORSUBBACKCOLORLIGHT
    else
      FPreview.Color := EDITORSUBBACKCOLORDARK;
  end;
  if Assigned(FBottomPanel) then
    SetEditorBackPanelAppearance(FBottomPanel);
  if Assigned(FButtonCancel) then
    SetEditorCancelButtonAppearance(FButtonCancel, FAppearance.ThemeColor);
  if Assigned(FButtonApply) then
  begin
    if Assigned(FButtonOk) then
      SetEditorCancelButtonAppearance(FButtonApply, FAppearance.ThemeColor)
    else
      SetEditorOKButtonAppearance(FButtonApply, FAppearance.ThemeColor, EDITORBUTTONROUNDING, FAppearance.ThemeFontColor);
  end;
  if Assigned(FButtonOk) then
    SetEditorOKButtonAppearance(FButtonOk, FAppearance.ThemeColor, EDITORBUTTONROUNDING, FAppearance.ThemeFontColor);
  if Assigned(FExpressionEdit) then
    SetEditorEditAppearance(FExpressionEdit);
  if Assigned(FTopPanel) then
    SetEditorSubPanelAppearance(FTopPanel);
end;

procedure TTMSFNCCustomFilterDialog.SetFilterBuilder(const Value: TTMSFNCFilterBuilder);
var
  e: TNotifyEvent;
begin
  if FFilterBuilder <> Value then
  begin
    if Assigned(FFilterBuilder) then
      TFBOpen(FFilterBuilder).OnInternalChanged := nil;

    e := nil;
    try
      FFilterBuilder := Value;

      if Assigned(FFilterBuilder) then
      begin
        e := TFBOpen(FFilterBuilder).OnChanged;
        TFBOpen(FFilterBuilder).OnChanged := nil;
        FFilterBuilder.FilterText := FilterText;
      end
      else
        FFilterText := '';

    finally
      if Assigned(FFilterBuilder) then
      begin
        TFBOpen(FFilterBuilder).OnInternalChanged := DoOnInternalFilterBuilderChanged;
        TFBOpen(FFilterBuilder).OnChanged := e;
      end;
    end;
  end;
end;

procedure TTMSFNCCustomFilterDialog.SetFilterText(const Value: string);
begin
  if Assigned(FFilterBuilder) then
  begin
    FFilterBuilder.FilterText := Value;
    FFilterText := FFilterBuilder.DisplayFilterText;
  end
  else
    FFilterText := Value;
end;

procedure TTMSFNCCustomFilterDialog.SetOptions(const Value: TTMSFNCFilterDialogOptions);
begin
  FOptions.Assign(Value);
end;

{ TTMSFNCCustomDataSetFilterDialog }

procedure TTMSFNCCustomDataSetFilterDialog.AddDataSetColumns;
var
  I: Integer;
  dt: TTMSFNCFilterBuilderDataType;
  cp: TTMSFNCFilterBuilderColumnProperties;
  c: TTMSFNCFilterBuilderColumn;
  add: Boolean;
begin
  if Assigned(FDataSet) then
  begin
    FFilterBuilder.DataColumns.Clear;

    for I := 0 to FDataSet.Fields.Count - 1 do
    begin
      if FDataSet.Fields[I].FieldKind = fkData then
      begin
        case FDataSet.Fields[I].DataType of
          ftWord, ftInteger, ftAutoInc, ftLargeInt: dt := fdtNumber;
          ftFloat: dt := fdtFloat;
          ftDateTime, ftTimeStamp, ftTimeStampOffset: dt := fdtDateTime;
          ftDate: dt := fdtDate;
          ftTime: dt := fdtTime;
          ftBoolean: dt := fdtBoolean;
          ftString, ftWideString, ftFixedChar, ftMemo, ftWideMemo: dt := fdtText;
          ftBlob, {ftMemo,} ftGraphic: dt := fdtOther;
          else
            dt := fdtAutomatic;
        end;

        cp.Name := FDataSet.Fields[I].FieldName;
        cp.DataType := dt;

        add := True;
        DoBeforeAddColumn(FDataSet.Fields[I], cp, add);
        if add then
        begin
          c := FilterBuilder.AddDataColumn(cp.Name , cp.DataType, cp.DisplayName);
          DoAfterAddColumn(c);
        end;
      end;
    end;
  end;
end;

constructor TTMSFNCCustomDataSetFilterDialog.Create(AOwner: TComponent);
begin
  inherited;
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoAfterAddColumn(AColumn: TTMSFNCFilterBuilderColumn);
begin
  if Assigned(FOnAfterAddColumn) then
    FOnAfterAddColumn(Self, AColumn);
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoApplyClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
var
  fTxt: string;
begin
  if Assigned(OnApplyButtonClicked) then
    OnApplyButtonClicked(Self, AFilterBuilder, AClose)
  else if Assigned(FDataSet) then
  begin
    fTxt := Trim(FilterText);
    FDataSet.Filtered := False;
    FDataSet.Filter := fTxt;
    if fTxt <> '' then
      FDataSet.Filtered := True;
  end;
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoBeforeAddColumn(AField: TField; var AColumnProperties: TTMSFNCFilterBuilderColumnProperties; var AAdd: Boolean);
begin
  if Assigned(FOnBeforeAddColumn) then
    FOnBeforeAddColumn(Self, AField, AColumnProperties, AAdd);
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoBeforeExecute;
begin
  AddDataSetColumns;

  if FFilterBuilder.DisplayFilterText <> FFilterText then
    SetFilterText(FFilterText);
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoCancelClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
begin
  if Assigned(OnCancelButtonClicked) then
    OnCancelButtonClicked(Self, AFilterBuilder, AClose)
  else if Assigned(FDataSet) then
  begin
    FDataSet.Filter := FCopyFilterText;
    if FCopyFilterText <> '' then
      FDataSet.Filtered := True;
  end;
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoGetExpressionValueList(AColumn: TTMSFNCFilterBuilderColumn; AValues: TStringList);
var
  s: string;
  ds: TDataSet;
  f: TField;
  b, fd: Boolean;
begin
  if Assigned(FDataSet) and FDataSet.Active then
  begin
    if Assigned(FOnGetExpressionValues) then
      FOnGetExpressionValues(Self, AColumn, AValues)
    else
    begin
      f := FDataSet.FieldByName(AColumn.Name);

      if Assigned(f) and Assigned(f.DataSet) then
      begin
        f.DataSet.DisableControls;

        fd := f.DataSet.Filtered;
        f.DataSet.Filtered := False;

        {$IFDEF SUPPORTCLONING}
        ds := f.DataSet.GetClonedDataSet(True);
        {$ELSE}
        ds := nil;
        {$ENDIF}

        b := False;
        if not Assigned(ds) then
        begin
          ds := f.DataSet;
          b := True;
        end;

        if Assigned(ds) then
        begin
          try
            ds.First;

            while not ds.Eof do
            begin
              s := ds.FieldByName(f.FieldName).AsString;
              AValues.Add(s);
              ds.Next;
            end;

          finally
            if not b then
              ds.Free;

            f.DataSet.Filtered := fd;

            f.DataSet.EnableControls;
          end;
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoGetModalResult(AModalResult: TModalResult);
begin
  inherited;
end;

procedure TTMSFNCCustomDataSetFilterDialog.DoOKClicked(AFilterBuilder: TTMSFNCFilterBuilder; var AClose: Boolean);
var
  fTxt: string;
begin
  if Assigned(OnOKButtonClicked) then
    OnOKButtonClicked(Self, AFilterBuilder, AClose)
  else if Assigned(FDataSet) then
  begin
    fTxt := Trim(FilterText);
    FDataSet.Filtered := False;
    FDataSet.Filter := fTxt;
    if fTxt <> '' then
      FDataSet.Filtered := True;
  end;
end;

function TTMSFNCCustomDataSetFilterDialog.GetFilterText: string;
begin
  if not FDialogOpen and Assigned(FDataSet) then
    inherited SetFilterText(FDataSet.Filter);
  Result := inherited GetFilterText;
end;

procedure TTMSFNCCustomDataSetFilterDialog.Notification(AComponent: TComponent; AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FDataSet) then
    FDataSet := nil;
end;

procedure TTMSFNCCustomDataSetFilterDialog.SetDataSet(const Value: TDataSet);
begin
  if FDataSet <> Value then
  begin
    FDataSet := Value;

    if Assigned(FDataSet) then
    begin
      AddDataSetColumns;
      FilterText := FDataSet.Filter;
    end;
  end;
end;

procedure TTMSFNCCustomDataSetFilterDialog.SetFilterText(const Value: string);
var
  df: Boolean;
begin
  inherited SetFilterText(Value);
  if Assigned(FDataSet) then
  begin
    df := FDataSet.Filtered;
    FDataSet.Filtered := False;
    FDataSet.Filter := FFilterBuilder.FilterText;

    if df and (FFilterBuilder.FilterText <> '') then
      FDataSet.Filtered := True;
  end;
end;

{ TTMSFNCFilterDialog }

constructor TTMSFNCFilterDialog.Create(AOwner: TComponent);
begin
  inherited;
  FFilterBuilder.FormatType := fftUniversalFilterExpressions;
end;

{ TTMSFNCFilterBuilderUILanguage }

procedure TTMSFNCFilterDialogUILanguage.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCFilterDialogUILanguage then
  begin
    FClose := (Source as TTMSFNCFilterDialogUILanguage).Close;
    FApply := (Source as TTMSFNCFilterDialogUILanguage).Apply;
    FOK := (Source as TTMSFNCFilterDialogUILanguage).OK;
    FCaption := (Source as TTMSFNCFilterDialogUILanguage).Caption;
    FAndOperatorText := (Source as TTMSFNCFilterDialogUILanguage).AndOperatorText;
    FOrOperatorText := (Source as TTMSFNCFilterDialogUILanguage).OrOperatorText;
    FEmptyOperatorText := (Source as TTMSFNCFilterDialogUILanguage).EmptyOperatorText;
    FEqualOperatorText := (Source as TTMSFNCFilterDialogUILanguage).EqualOperatorText;
    FLargerThanOrEqualOperatorText := (Source as TTMSFNCFilterDialogUILanguage).LargerThanOrEqualOperatorText;
    FLargerThanOperatorText := (Source as TTMSFNCFilterDialogUILanguage).LargerThanOperatorText;
    FSmallerThanOrEqualOperatorText := (Source as TTMSFNCFilterDialogUILanguage).SmallerThanOrEqualOperatorText;
    FSmallerThanOperatorText := (Source as TTMSFNCFilterDialogUILanguage).SmallerThanOperatorText;
    FNotEmptyOperatorText := (Source as TTMSFNCFilterDialogUILanguage).NotEmptyOperatorText;
    FNotEqualOperatorText := (Source as TTMSFNCFilterDialogUILanguage).NotEqualOperatorText;
    FStartsWithOperatorText := (Source as TTMSFNCFilterDialogUILanguage).StartsWithOperatorText;
    FEndsWithOperatorText := (Source as TTMSFNCFilterDialogUILanguage).EndsWithOperatorText;
    FContainsOperatorText := (Source as TTMSFNCFilterDialogUILanguage).ContainsOperatorText;
    FNotContainsOperatorText := (Source as TTMSFNCFilterDialogUILanguage).NotContainsOperatorText;
    FTrueText := (Source as TTMSFNCFilterDialogUILanguage).TrueText;
    FFalseText := (Source as TTMSFNCFilterDialogUILanguage).FalseText;
    FAddHint := (Source as TTMSFNCFilterDialogUILanguage).AddHint;
    FRemoveHint := (Source as TTMSFNCFilterDialogUILanguage).RemoveHint;
    FNotHint := (Source as TTMSFNCFilterDialogUILanguage).NotHint;
    FColumnNameHint := (Source as TTMSFNCFilterDialogUILanguage).ColumnNameHint;
    FOperatorHint := (Source as TTMSFNCFilterDialogUILanguage).OperatorHint;
    FValueHint := (Source as TTMSFNCFilterDialogUILanguage).ValueHint;
  end
  else
    inherited;
end;

procedure TTMSFNCFilterDialogUILanguage.DoChanged;
begin
  if Assigned(FOnInternalChanged) then
    FOnInternalChanged(Self);
end;

constructor TTMSFNCFilterDialogUILanguage.Create;
begin
  FApply := TranslateTextEx(sTMSFNCFilterBuilderUILanguageApply);
  FOk := TranslateTextEx(sTMSFNCFilterBuilderUILanguageOk);
  FClear := TranslateTextEx(sTMSFNCFilterBuilderUILanguageClear);  
  FCancel := TranslateTextEx(sTMSFNCFilterBuilderUILanguageCancel);    
  FClose := TranslateTextEx(sTMSFNCFilterBuilderUILanguageClose);
  FCaption := TranslateTextEx(sTMSFNCFilterBuilderUILanguageCaption);
  FAndOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageAndOperatorText);
  FOrOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageOrOperatorText);
  FEmptyOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageEmptyOperatorText);
  FEqualOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageEqualOperatorText);
  FLargerThanOrEqualOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageLargerThanOrEqualOperatorText);
  FLargerThanOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageLargerThanOperatorText);
  FSmallerThanOrEqualOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageSmallerThanOrEqualOperatorText);
  FSmallerThanOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageSmallerThanOperatorText);
  FNotEmptyOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotEmptyOperatorText);
  FNotEqualOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotEqualOperatorText);
  FStartsWithOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageStartsWithOperatorText);
  FEndsWithOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageEndsWithOperatorText);
  FContainsOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageContainsOperatorText);
  FNotContainsOperatorText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotContainsOperatorText);
  FAddExpression := TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddExpression);
  FAddGroup := TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddGroup);
  FTrueText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageTrue);
  FFalseText := TranslateTextEx(sTMSFNCFilterBuilderUILanguageFalse);
  FAddHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddHint);
  FRemoveHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageRemoveHint);
  FNotHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotHint);
  FColumnNameHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageColumnNameHint);
  FOperatorHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageOperatorHint);
  FValueHint := TranslateTextEx(sTMSFNCFilterBuilderUILanguageValueHint);
end;

function TTMSFNCFilterDialogUILanguage.IsAddExpressionStored: Boolean;
begin
  Result := FAddExpression <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddExpression);
end;

function TTMSFNCFilterDialogUILanguage.IsAddGroupStored: Boolean;
begin
  Result := FAddGroup <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddGroup);
end;

function TTMSFNCFilterDialogUILanguage.IsAddHintStored: Boolean;
begin
  Result := FAddHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageAddHint);
end;

function TTMSFNCFilterDialogUILanguage.IsAndOperatorTextStored: Boolean;
begin
  Result := FAndOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageAndOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsApplyStored: Boolean;
begin
  Result := FApply <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageApply);
end;

function TTMSFNCFilterDialogUILanguage.IsOKStored: Boolean;
begin
  Result := FOk <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageOk);
end;

function TTMSFNCFilterDialogUILanguage.IsOperatorHintStored: Boolean;
begin
  Result := FOperatorHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageOperatorHint);
end;

function TTMSFNCFilterDialogUILanguage.IsOrOperatorTextStored: Boolean;
begin
  Result := FAndOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageOrOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsRemoveHintStored: Boolean;
begin
  Result := FRemoveHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageRemoveHint);
end;

function TTMSFNCFilterDialogUILanguage.IsStartsWithOperatorTextStored: Boolean;
begin
  Result := FStartsWithOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageStartsWithOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsValueHintStored: Boolean;
begin
  Result := FValueHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageValueHint);
end;

function TTMSFNCFilterDialogUILanguage.TrueOperatorTextStored: Boolean;
begin
  Result := FTrueText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageTrue);
end;

function TTMSFNCFilterDialogUILanguage.IsCancelStored: Boolean;
begin
  Result := FCancel <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageCancel);
end;

function TTMSFNCFilterDialogUILanguage.IsCaptionStored: Boolean;
begin
  Result := FCaption <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageCaption);
end;

//function TTMSFNCFilterDialogUILanguage.IsCaseHintStored: Boolean;
//begin
//  Result := FCaseHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageCaseHint);
//end;

function TTMSFNCFilterDialogUILanguage.IsClearStored: Boolean;
begin
  Result := FClear <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageClear);
end;

function TTMSFNCFilterDialogUILanguage.IsCloseStored: Boolean;
begin
  Result := FClose <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageClose);
end;

function TTMSFNCFilterDialogUILanguage.IsColumnNameHintStored: Boolean;
begin
  Result := FColumnNameHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageColumnNameHint);
end;

function TTMSFNCFilterDialogUILanguage.IsContainsOperatorTextStored: Boolean;
begin
  Result := FContainsOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageContainsOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsEmptyOperatorTextStored: Boolean;
begin
  Result := FEmptyOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageEmptyOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsEndsWithOperatorTextStored: Boolean;
begin
  Result := FEndsWithOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageEndsWithOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsEqualOperatorTextStored: Boolean;
begin
  Result := FEqualOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageEqualOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.FalseOperatorTextStored: Boolean;
begin
  Result := FFalseText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageFalse);
end;

function TTMSFNCFilterDialogUILanguage.IsLargerThanOrEqualOperatorTextStored: Boolean;
begin
  Result := FLargerThanOrEqualOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageLargerThanOrEqualOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsLargerThanOperatorTextStored: Boolean;
begin
  Result := FLargerThanOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageLargerThanOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsSmallerThanOrEqualOperatorTextStored: Boolean;
begin
  Result := FSmallerThanOrEqualOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageSmallerThanOrEqualOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsSmallerThanOperatorTextStored: Boolean;
begin
  Result := FSmallerThanOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageSmallerThanOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsNotContainsOperatorTextStored: Boolean;
begin
  Result := FNotContainsOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotContainsOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsNotEmptyOperatorTextStored: Boolean;
begin
  Result := FNotEmptyOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotEmptyOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsNotEqualOperatorTextStored: Boolean;
begin
  Result := FNotEqualOperatorText <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotEqualOperatorText);
end;

function TTMSFNCFilterDialogUILanguage.IsNotHintStored: Boolean;
begin
  Result := FNotHint <> TranslateTextEx(sTMSFNCFilterBuilderUILanguageNotHint);
end;

{ TTMSFNCFilterDialogCustomOptions }

procedure TTMSFNCFilterDialogCustomOptions.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCFilterDialogCustomOptions then
  begin
    FUILanguage.Assign((Source as TTMSFNCFilterDialogCustomOptions).UILanguage);
    FButtons := (Source as TTMSFNCFilterDialogCustomOptions).Buttons;
  end
  else
    inherited;
end;

constructor TTMSFNCFilterDialogCustomOptions.Create(AOwner: TComponent);
begin
  inherited Create;

  FUILanguage := TTMSFNCFilterDialogUILanguage.Create;
  FButtons := [fdbApply, fdbClear, fdbCancel];
end;

destructor TTMSFNCFilterDialogCustomOptions.Destroy;
begin
  FUILanguage.Free;
  inherited;
end;

procedure TTMSFNCFilterDialogCustomOptions.DoInternalChanged;
begin
  if Assigned(OnInternalChanged) then
    OnInternalChanged(Self);
end;

function TTMSFNCFilterDialogCustomOptions.IsButtonsStored: Boolean;
begin
  Result := FButtons <>  [fdbApply, fdbClear, fdbCancel];
//  Result := not ((fdbApply in FButtons) and (fdbCancel in FButtons) and (fdbClear in FButtons) and not (fdbOk in FButtons));
end;

procedure TTMSFNCFilterDialogCustomOptions.SetButtons(const Value: TTMSFNCFilterDialogButtons);
begin
  if FButtons <> Value then
  begin
    FButtons := Value;
    DoInternalChanged;
  end;
end;

procedure TTMSFNCFilterDialogCustomOptions.SetUILanguage(const Value: TTMSFNCFilterDialogUILanguage);
begin
  FUILanguage.Assign(Value);
  DoInternalChanged;
end;

{ TTMSFNCFilterDialogAppearance }

procedure TTMSFNCFilterDialogAppearance.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCFilterDialogAppearance) then
  begin
    FGroupFill.Assign((Source as TTMSFNCFilterDialogAppearance).GroupFill);
    FExpressionColumnFill.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionColumnFill);
    FExpressionOperatorFill.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionOperatorFill);
    FExpressionValueFill.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionValueFill);
    FGroupFont.Assign((Source as TTMSFNCFilterDialogAppearance).GroupFont);
    FExpressionColumnFont.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionColumnFont);
    FExpressionOperatorFont.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionOperatorFont);
    FExpressionValueFont.Assign((Source as TTMSFNCFilterDialogAppearance).ExpressionValueFont);
    FConnectionLine.Assign((Source as TTMSFNCFilterDialogAppearance).ConnectionLine);
    FHoverFill.Assign((Source as TTMSFNCFilterDialogAppearance).HoverFill);
    FDropDownHoverFill.Assign((Source as TTMSFNCFilterDialogAppearance).DropDownHoverFill);
    FDropDownHoverFont.Assign((Source as TTMSFNCFilterDialogAppearance).DropDownHoverFont);
    FHoverPartStroke.Assign((Source as TTMSFNCFilterDialogAppearance).HoverPartStroke);
    FItemControlsMargins.Assign((Source as TTMSFNCFilterDialogAppearance).ItemControlsMargins);
    FIndent := (Source as TTMSFNCFilterDialogAppearance).Indent;
    FItemHeight := (Source as TTMSFNCFilterDialogAppearance).ItemHeight;
    FThemeColor := (Source as TTMSFNCFilterDialogAppearance).ThemeColor;
    FThemeFontColor := (Source as TTMSFNCFilterDialogAppearance).ThemeFontColor;
  end
  else
    inherited;
end;

procedure TTMSFNCFilterDialogAppearance.ChangeDPIScale(M, D: Integer);
begin
  FGroupFont.Height := TTMSFNCUtils.MulDivInt(FGroupFont.Height, M, D);
  FExpressionColumnFont.Height := TTMSFNCUtils.MulDivInt(FExpressionColumnFont.Height, M, D);
  FExpressionOperatorFont.Height := TTMSFNCUtils.MulDivInt(FExpressionOperatorFont.Height, M, D);
  FExpressionValueFont.Height := TTMSFNCUtils.MulDivInt(FExpressionValueFont.Height, M, D);
  FDropDownHoverFont.Height := TTMSFNCUtils.MulDivInt(FDropDownHoverFont.Height, M, D);

  FItemControlsMargins.Top := TTMSFNCUtils.MulDivSingle(FItemControlsMargins.Top, M, D);
  FItemControlsMargins.Bottom := TTMSFNCUtils.MulDivSingle(FItemControlsMargins.Bottom, M, D);
  FItemControlsMargins.Left := TTMSFNCUtils.MulDivSingle(FItemControlsMargins.Left, M, D);
  FItemControlsMargins.Right := TTMSFNCUtils.MulDivSingle(FItemControlsMargins.Right, M, D);
  FIndent := TTMSFNCUtils.MulDivInt(FIndent, M, D);
  FItemHeight := TTMSFNCUtils.MulDivInt(FItemHeight, M, D);
  FItemRounding := TTMSFNCUtils.MulDivInt(FItemRounding, M, D);
end;

constructor TTMSFNCFilterDialogAppearance.Create(AOwner: TComponent);
begin
  FThemeColor := EDITORPRIMCOLOR;
  FThemeFontColor := gcWhite;
  FGroupFill := TTMSFNCGraphicsFill.Create(gfkSolid, EDITORPRIMCOLOR);
  FExpressionColumnFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcDarkgreen);
  FExpressionOperatorFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcDarkviolet);
  FExpressionValueFill := TTMSFNCGraphicsFill.Create(gfkSolid, gcDarkblue);
  FHoverFill := TTMSFNCGraphicsFill.Create(gfkSolid, MakeGraphicsColor(149, 213, 246));
  FDropDownHoverFill := TTMSFNCGraphicsFill.Create(gfkSolid, MakeGraphicsColor(149, 213, 246));

  FGroupFill.OnChanged := @DoOnFillChanged;
  FExpressionColumnFill.OnChanged := @DoOnFillChanged;
  FExpressionOperatorFill.OnChanged := @DoOnFillChanged;
  FExpressionValueFill.OnChanged := @DoOnFillChanged;
  FHoverFill.OnChanged := @DoOnFillChanged;
  FDropDownHoverFill.OnChanged := @DoOnFillChanged;

  FGroupFont := TTMSFNCGraphicsFont.Create;
  FGroupFont.Color := gcWhite;
  FExpressionColumnFont := TTMSFNCGraphicsFont.Create;
  FExpressionColumnFont.Color := gcWhite;
  FExpressionOperatorFont := TTMSFNCGraphicsFont.Create;
  FExpressionOperatorFont.Color := gcWhite;
  FExpressionValueFont := TTMSFNCGraphicsFont.Create;
  FExpressionValueFont.Color := gcWhite;

  FDropDownHoverFont := TTMSFNCGraphicsFont.Create;
  FDropDownHoverFont.Color := MakeGraphicsColor(45, 45, 45);

  FGroupFont.OnChanged := @DoOnFontChanged;
  FExpressionColumnFont.OnChanged := @DoOnFontChanged;
  FExpressionOperatorFont.OnChanged := @DoOnFontChanged;
  FExpressionValueFont.OnChanged := @DoOnFontChanged;
  FDropDownHoverFont.OnChanged := @DoOnFontChanged;

  FConnectionLine := TTMSFNCGraphicsStroke.Create(gskDot, gcSlategray);
  FHoverPartStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcWhite);

  FConnectionLine.OnChanged := @DoOnStrokeChanged;
  FHoverPartStroke.OnChanged := @DoOnStrokeChanged;

  FItemControlsMargins := TTMSFNCMargins.Create;
  FItemControlsMargins.Top := 4;
  FItemControlsMargins.Bottom := 4;
  FItemControlsMargins.Left := 2;
  FItemControlsMargins.Right := 18;

  FDarkStyleControls := False;

  FIndent := 20;
  FItemHeight := 30;
  FItemRounding := 4;
end;

destructor TTMSFNCFilterDialogAppearance.Destroy;
begin
  FDropDownHoverFill.Free;
  FDropDownHoverFont.Free;
  FItemControlsMargins.Free;
  FConnectionLine.Free;
  FGroupFill.Free;
  FExpressionColumnFill.Free;
  FExpressionOperatorFill.Free;
  FExpressionValueFill.Free;
  FGroupFont.Free;
  FExpressionColumnFont.Free;
  FExpressionOperatorFont.Free;
  FExpressionValueFont.Free;
  FHoverFill.Free;
  FHoverPartStroke.Free;
  inherited;
end;

procedure TTMSFNCFilterDialogAppearance.DoChanged;
begin
  if Assigned(FOnInternalChanged) then
    FOnInternalChanged(Self);
end;

procedure TTMSFNCFilterDialogAppearance.DoDarkStyleChanged(AIsDark: Boolean);
begin
  if Assigned(FOnDarkStyleChanged) then
    FOnDarkStyleChanged(Self, AIsDark);
end;

procedure TTMSFNCFilterDialogAppearance.DoOnFillChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCFilterDialogAppearance.DoOnFontChanged(Sender: TObject);
begin
  DoChanged;
end;

procedure TTMSFNCFilterDialogAppearance.DoOnStrokeChanged(Sender: TObject);
begin
  DoChanged;
end;

function TTMSFNCFilterDialogAppearance.IsThemeColorStored: Boolean;
begin
  Result := FThemeColor <> EDITORPRIMCOLOR;
end;

function TTMSFNCFilterDialogAppearance.IsThemeFontColorStored: Boolean;
begin
  Result := FThemeFontColor <> gcWhite;
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionColumnFill(const Value: TTMSFNCGraphicsFill);
begin
  FExpressionColumnFill.Assign(Value);
  DoOnFillChanged(FExpressionColumnFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionColumnFont(const Value: TTMSFNCGraphicsFont);
begin
  FExpressionColumnFont.Assign(Value);
  DoOnFontChanged(FExpressionColumnFont);
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionOperatorFill(const Value: TTMSFNCGraphicsFill);
begin
  FExpressionOperatorFill.Assign(Value);
  DoOnFillChanged(FExpressionOperatorFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionOperatorFont(const Value: TTMSFNCGraphicsFont);
begin
  FExpressionOperatorFont.Assign(Value);
  DoOnFontChanged(FExpressionOperatorFont);
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionValueFill(const Value: TTMSFNCGraphicsFill);
begin
  FExpressionValueFill.Assign(Value);
  DoOnFillChanged(FExpressionValueFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetExpressionValueFont(const Value: TTMSFNCGraphicsFont);
begin
  FExpressionValueFont.Assign(Value);
  DoOnFontChanged(FExpressionValueFont);
end;

procedure TTMSFNCFilterDialogAppearance.SetGroupFill(const Value: TTMSFNCGraphicsFill);
begin
  FGroupFill.Assign(Value);
  DoOnFillChanged(FGroupFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetGroupFont(const Value: TTMSFNCGraphicsFont);
begin
  FGroupFont.Assign(Value);
  DoOnFontChanged(FGroupFont);
end;
procedure TTMSFNCFilterDialogAppearance.SetHoverFill(const Value: TTMSFNCGraphicsFill);
begin
  FHoverFill.Assign(Value);
  DoOnFillChanged(FHoverFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetHoverPartStroke(const Value: TTMSFNCGraphicsStroke);
begin
  FHoverPartStroke.Assign(Value);
  DoOnStrokeChanged(FHoverPartStroke);
end;

procedure TTMSFNCFilterDialogAppearance.SetConnectionLine(const Value: TTMSFNCGraphicsStroke);
begin
  FConnectionLine.Assign(Value);
  DoOnStrokeChanged(FConnectionLine);
end;

procedure TTMSFNCFilterDialogAppearance.SetDarkStyleControls(const Value: Boolean);
begin
  if FDarkStyleControls <> Value then
  begin
    FDarkStyleControls := Value;
    DoDarkStyleChanged(FDarkStyleControls);
  end;
end;

procedure TTMSFNCFilterDialogAppearance.SetDropDownHoverFill(const Value: TTMSFNCGraphicsFill);
begin
  FDropDownHoverFill.Assign(Value);
  DoOnFillChanged(FDropDownHoverFill);
end;

procedure TTMSFNCFilterDialogAppearance.SetDropDownHoverFont(const Value: TTMSFNCGraphicsFont);
begin
  FDropDownHoverFont.Assign(Value);
  DoOnFontChanged(FDropDownHoverFont);
end;

procedure TTMSFNCFilterDialogAppearance.SetIndent(const Value: Integer);
begin
  if FIndent <> Value then
  begin
    FIndent := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCFilterDialogAppearance.SetItemControlsMargins(const Value: TTMSFNCMargins);
begin
  FItemControlsMargins.Assign(Value);
  DoChanged;
end;

procedure TTMSFNCFilterDialogAppearance.SetItemHeight(const Value: Integer);
begin
  if FItemHeight <> Value then
  begin
    FItemHeight := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCFilterDialogAppearance.SetItemRounding(const Value: Integer);
begin
  if FItemRounding <> Value then
  begin
    FItemRounding := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCFilterDialogAppearance.SetThemeColor(const Value: TTMSFNCGraphicsColor);
begin
  if FThemeColor <> Value then
  begin
    FThemeColor := Value;
    DoChanged;
  end;
end;

procedure TTMSFNCFilterDialogAppearance.SetThemeFontColor(const Value: TTMSFNCGraphicsColor);
begin
  FThemeFontColor := Value;
end;

{ TTMSFNCFilterDialogDrawItem }

constructor TTMSFNCFilterDialogDrawItem.Create;
begin
  FExpression := nil;
  FGroup := nil;
  FIsSelected := False;
  FRect := RectF(-1,-1,-1,-1);
  FColumnNameRect := FRect;
  FOperatorRect := FRect;
  FValueRect := FRect;
  FColumnNameArrowRect := FRect;
  FOperatorArrowRect := FRect;
  FValueArrowRect := FRect;
  FColumnNameTextRect := FRect;
  FOperatorTextRect := FRect;
  FValueTextRect := FRect;
  FExtraValueRect := FRect;
  FExtraValueTextRect := FRect;
  FExtraValueArrowRect := FRect;
  FNotRect := FRect;
  FAddRect := FRect;
  FDeleteRect := FRect;
//  FCaseRect := FRect;
  FArrowSpace := 20;
  FColumnNameText := '';
  FOperatorText := '';
  FValueText := '';
  FExtraValueText:= '';
  FValueType := fdtAutomatic;
  FLevel := -1;
  FIndex := -1;
  FEndIndex := -1;
  FRounding := 4;
  FIsInverted := False;
//  FCaseSensitive := False;
  FValue := TValueToFNCValue(TValue.Empty);
end;

destructor TTMSFNCFilterDialogDrawItem.Destroy;
begin
  FGroup := nil;
  FExpression := nil;
  inherited;
end;

{ TTMSFNCFilterDialogDrawItemList }

function TTMSFNCFilterDialogDrawItemList.AddItem: TTMSFNCFilterDialogDrawItem;
var
  it: TTMSFNCFilterDialogDrawItem;
begin
  it := TTMSFNCFilterDialogDrawItem.Create;
  it.Index := Count;
  it.EndIndex := it.Index;
  inherited Add(it);

  Result := it;
end;

function TTMSFNCFilterDialogDrawItemList.AddItem(AGroup: TTMSFNCFilterBuilderGroup; ALevel: Integer = -1): TTMSFNCFilterDialogDrawItem;
begin
  Result := AddItem;
  Result.Level := ALevel;
  Result.Group := AGroup;
end;

function TTMSFNCFilterDialogDrawItemList.AddItem(AExpression: TTMSFNCFilterBuilderExpression; ALevel: Integer = -1): TTMSFNCFilterDialogDrawItem;
begin
  Result := AddItem;
  Result.Level := ALevel;
  Result.Expression := AExpression;
end;

{ TTMSFNCFilterPreview }

constructor TTMSFNCFilterPreview.Create(AOwner: TComponent);
begin
  inherited Create(AOwner);

  {$IFDEF VCLLIB}
  NativeCanvas := True;
  TextQuality := gtqClearType
  {$ENDIF}
end;

function TTMSFNCFilterPreview.GetHintString: string;
begin
  Result := inherited GetHintString;
  if Assigned(FDialog) then
  begin
    if FDialog.FHoveredItemIndex >= 0 then
    begin
      case FDialog.FHoverItemPart of
        ddipName: Result := Dialog.Options.UILanguage.ColumnNameHint;
        ddipOperator: Result := Dialog.Options.UILanguage.OperatorHint;
        ddipValue,ddipExtraValue: Result := Dialog.Options.UILanguage.ValueHint;
        ddipAdd: Result := Dialog.Options.UILanguage.AddHint;
        ddipDelete: Result := Dialog.Options.UILanguage.RemoveHint;
        ddipNot: Result := Dialog.Options.UILanguage.NotHint;
//        ddipCase: Result := Dialog.Options.UILanguage.CaseHint;
      end;
    end;
  end;
end;

function TTMSFNCFilterPreview.HasHint: Boolean;
begin
  Result := False;
  if Assigned(FDialog) then
  begin
    if FDialog.FHoveredItemIndex >= 0 then
    begin
      case FDialog.FHoverItemPart of
        ddipName,ddipOperator,
        ddipValue,ddipExtraValue,
        ddipAdd, ddipDelete,
        ddipNot{, ddipCase}: Result := True;
      end;
    end;
  end;
end;

{$IFDEF WEBLIB}
initialization
begin
  TTMSFNCBitmap.CreateFromResource(TTMSFNCADDBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCREMOVEBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCNOTBITMAP);
//  TTMSFNCBitmap.CreateFromResource(TTMSFNCCASEBITMAP);
end;
{$ENDIF}

end.
